import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _wrapNativeSuper from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _toArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toArray.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["dataFromPreviewApp"],
    _excluded2 = ["dataFromPreviewApp"];
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/esnext.global-this.js";
import "core-js/modules/esnext.string.match-all.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var mt = Object.defineProperty;

var Ot = function Ot(e, t, n) {
  return t in e ? mt(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: n
  }) : e[t] = n;
};

var p = function p(e, t, n) {
  return Ot(e, typeof t != "symbol" ? t + "" : t, n), n;
};

var Be = "2.17.3";
var Me = !1;

function _e(e) {
  Me = e;
}

var W = function W(e) {
  return function () {
    var _console;

    Me && (_console = console)[e].apply(_console, arguments);
  };
},
    _ = {
  error: W("error"),
  warn: W("warn"),
  log: W("log")
},
    St = /* @__PURE__ */new Set(["Symbol", "Text", "Integer", "Number", "Boolean", "Date", "Location", "Object"]);

function ue(_ref) {
  var _ref2;

  var e = _ref.dataFromPreviewApp,
      t = _ref.updateFromEntryEditor,
      n = _ref.name;
  var s;
  e[n] = (_ref2 = (s = t.fields) == null ? void 0 : s[n]) !== null && _ref2 !== void 0 ? _ref2 : null;
}

function Ue(e) {
  var t;
  return !!(St.has(e.type) || e.type === "Array" && ((t = e.items) == null ? void 0 : t.type) === "Symbol");
}

var Y = 10,
    Dt = "live-preview-editor",
    gt = "live-preview-sdk";

function g(e, t, n) {
  var s = _objectSpread(_objectSpread({}, t), {}, {
    method: e,
    from: "live-preview",
    source: gt,
    location: window.location.href,
    version: Be
  });

  _.log("Send message", s), n.forEach(function (i) {
    var r;
    (r = window.top) == null || r.postMessage(s, i);
  });
}

function Xn(e) {
  var _this = this;

  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var n;
  return function () {
    for (var _len = arguments.length, s = new Array(_len), _key = 0; _key < _len; _key++) {
      s[_key] = arguments[_key];
    }

    clearTimeout(n), n = setTimeout(function () {
      e.apply(_this, s);
    }, t);
  };
}

var At = /*#__PURE__*/function () {
  function At(t, n) {
    _classCallCheck(this, At);

    p(this, "storageKey");
    p(this, "value");
    this.storageKey = t, this.value = this.restoreSessionData() || n;
  }

  _createClass(At, [{
    key: "getKey",
    value: function getKey(t, n) {
      return "".concat(t, "-").concat(n);
    }
  }, {
    key: "restoreSessionData",
    value: function restoreSessionData() {
      try {
        var t = window.sessionStorage.getItem(this.storageKey),
            n = t ? JSON.parse(t) : null;
        return Array.isArray(n) ? new Map(n) : null;
      } catch (_unused) {
        return null;
      }
    }
  }, {
    key: "get",
    value: function get(t, n) {
      return this.value.get(this.getKey(t, n));
    }
  }, {
    key: "set",
    value: function set(t, n, s) {
      this.value.set(this.getKey(t, n), s);

      try {
        window.sessionStorage.setItem(this.storageKey, JSON.stringify(Array.from(this.value.entries())));
      } catch (_unused2) {
        _.warn("StorageMap: Failed to set data for key \"".concat(t, "\" in sessionStorage"));
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.value.clear();

      try {
        window.sessionStorage.removeItem(this.storageKey);
      } catch (_unused3) {
        _.warn("StorageMap: Failed to clear data from sessionStorage");
      }
    }
  }]);

  return At;
}();

function Lt(e) {
  if (!e) return e;

  try {
    var t = new URL(e, "https://images.ctfassets.net");
    return t.protocol = "https:", t.href;
  } catch (t) {
    return _.error("Recevied invalid asset url \"".concat(e, "\""), t), e;
  }
}

function de(e) {
  if (typeof structuredClone == "function") return structuredClone(e);

  try {
    return JSON.parse(JSON.stringify(e));
  } catch (t) {
    return _.warn("Failed to clone data, updates are done on the original one", e, t), e;
  }
}

function Ct() {
  var e;

  try {
    return ((e = window.top) == null ? void 0 : e.location.href) !== window.location.href;
  } catch (_unused4) {
    return !0;
  }
}

function bt() {
  return "".concat(performance.now(), "-").concat(Math.random().toString(36).slice(2));
}

function vt(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var n = window.location.href;
  var i = setInterval(function () {
    var r = window.location.href;
    r !== n && (n = r, e(r));
  }, t);
  return function () {
    return clearInterval(i);
  };
}

function Fe(e, t) {
  if (!t.length) return e;

  try {
    var _t2 = _toArray(t),
        n = _t2[0],
        s = _t2.slice(1);

    return Fe(e[n], s);
  } catch (_unused5) {
    return;
  }
}

function X(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

var Rt = /*#__PURE__*/function () {
  function Rt(_ref3) {
    var t = _ref3.entities,
        n = _ref3.locale;

    _classCallCheck(this, Rt);

    X(this, "locale", void 0), X(this, "entryMap", /* @__PURE__ */new Map()), X(this, "assetMap", /* @__PURE__ */new Map()), this.locale = n;

    var _iterator = _createForOfIteratorHelper(t),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var s = _step.value;
        this.addEntity(s);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  _createClass(Rt, [{
    key: "entities",
    get: function get() {
      return [].concat(_toConsumableArray(this.entryMap.values()), _toConsumableArray(this.assetMap.values()));
    }
  }, {
    key: "updateEntity",
    value: function updateEntity(t) {
      this.addEntity(t);
    }
  }, {
    key: "getValue",
    value: function getValue(t, n) {
      t.sys.type;
      var s = this.getEntity(t.sys.linkType, t.sys.id);

      if (!s) {
        console.warn("Unresolved entity reference: ".concat(t));
        return;
      }

      return Fe(s, n);
    }
  }, {
    key: "getEntitiesFromMap",
    value: function getEntitiesFromMap(t, n) {
      var s = [],
          i = [];

      var _iterator2 = _createForOfIteratorHelper(n),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var r = _step2.value;
          var a = this.getEntity(t, r);
          a ? s.push(a) : i.push(r);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return {
        resolved: s,
        missing: i
      };
    }
  }, {
    key: "addEntity",
    value: function addEntity(t) {
      this.isAsset(t) ? this.assetMap.set(t.sys.id, t) : this.entryMap.set(t.sys.id, t);
    }
  }, {
    key: "fetchAsset",
    value: function () {
      var _fetchAsset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t) {
        var _this$getEntitiesFrom, n, s;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$getEntitiesFrom = this.getEntitiesFromMap("Asset", [t]), n = _this$getEntitiesFrom.resolved, s = _this$getEntitiesFrom.missing;

                if (!s.length) {
                  _context.next = 4;
                  break;
                }

                console.warn("Asset \"".concat(t, "\" is not in the store"));
                return _context.abrupt("return");

              case 4:
                return _context.abrupt("return", n[0]);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchAsset(_x) {
        return _fetchAsset.apply(this, arguments);
      }

      return fetchAsset;
    }()
  }, {
    key: "fetchAssets",
    value: function () {
      var _fetchAssets = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(t) {
        var _this$getEntitiesFrom2, n, s;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$getEntitiesFrom2 = this.getEntitiesFromMap("Asset", t), n = _this$getEntitiesFrom2.resolved, s = _this$getEntitiesFrom2.missing;

                if (!s.length) {
                  _context2.next = 3;
                  break;
                }

                throw new Error("Missing assets in the store (".concat(s.join(","), ")"));

              case 3:
                return _context2.abrupt("return", n);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchAssets(_x2) {
        return _fetchAssets.apply(this, arguments);
      }

      return fetchAssets;
    }()
  }, {
    key: "fetchEntry",
    value: function () {
      var _fetchEntry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(t) {
        var _this$getEntitiesFrom3, n, s;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$getEntitiesFrom3 = this.getEntitiesFromMap("Entry", [t]), n = _this$getEntitiesFrom3.resolved, s = _this$getEntitiesFrom3.missing;

                if (!s.length) {
                  _context3.next = 4;
                  break;
                }

                console.warn("Entry \"".concat(t, "\" is not in the store"));
                return _context3.abrupt("return");

              case 4:
                return _context3.abrupt("return", n[0]);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchEntry(_x3) {
        return _fetchEntry.apply(this, arguments);
      }

      return fetchEntry;
    }()
  }, {
    key: "fetchEntries",
    value: function () {
      var _fetchEntries = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(t) {
        var _this$getEntitiesFrom4, n, s;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this$getEntitiesFrom4 = this.getEntitiesFromMap("Entry", t), n = _this$getEntitiesFrom4.resolved, s = _this$getEntitiesFrom4.missing;

                if (!s.length) {
                  _context4.next = 3;
                  break;
                }

                throw new Error("Missing assets in the store (".concat(s.join(","), ")"));

              case 3:
                return _context4.abrupt("return", n);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function fetchEntries(_x4) {
        return _fetchEntries.apply(this, arguments);
      }

      return fetchEntries;
    }()
  }, {
    key: "isAsset",
    value: function isAsset(t) {
      return t.sys.type === "Asset";
    }
  }, {
    key: "getEntity",
    value: function getEntity(t, n) {
      return t === "Asset" ? this.assetMap.get(n) : this.entryMap.get(n);
    }
  }]);

  return Rt;
}();

function M(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

var Ie;

(function (e) {
  e.REQUEST_ENTITIES = "REQUEST_ENTITIES", e.REQUESTED_ENTITIES = "REQUESTED_ENTITIES";
})(Ie || (Ie = {}));

var xt = /*#__PURE__*/function (_Rt) {
  _inherits(xt, _Rt);

  var _super = _createSuper(xt);

  function xt(_ref4) {
    var _this2;

    var t = _ref4.entities,
        n = _ref4.locale,
        s = _ref4.sendMessage,
        i = _ref4.subscribe,
        _ref4$timeoutDuration = _ref4.timeoutDuration,
        r = _ref4$timeoutDuration === void 0 ? 3e3 : _ref4$timeoutDuration;

    _classCallCheck(this, xt);

    _this2 = _super.call(this, {
      entities: t,
      locale: n
    }), M(_assertThisInitialized(_this2), "requestCache", /* @__PURE__ */new Map()), M(_assertThisInitialized(_this2), "sendMessage", void 0), M(_assertThisInitialized(_this2), "subscribe", void 0), M(_assertThisInitialized(_this2), "timeoutDuration", void 0), M(_assertThisInitialized(_this2), "cacheIdSeperator", ","), _this2.sendMessage = s, _this2.subscribe = i, _this2.timeoutDuration = r;
    return _this2;
  }

  _createClass(xt, [{
    key: "cleanupPromise",
    value: function cleanupPromise(t) {
      var _this3 = this;

      setTimeout(function () {
        _this3.requestCache.delete(t);
      }, 300);
    }
  }, {
    key: "getCacheId",
    value: function getCacheId(t) {
      return t.length === 1 ? t[0] : t.join(this.cacheIdSeperator);
    }
  }, {
    key: "fetchEntity",
    value: function () {
      var _fetchEntity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(t, n) {
        var _this4 = this;

        var _this$getEntitiesFrom5, s, i, r, a, o;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this$getEntitiesFrom5 = this.getEntitiesFromMap(t, n), s = _this$getEntitiesFrom5.missing, i = _this$getEntitiesFrom5.resolved;

                if (!(s.length === 0)) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt("return", i);

              case 3:
                r = this.getCacheId(s), a = this.requestCache.get(r);

                if (!a) {
                  _context5.next = 6;
                  break;
                }

                return _context5.abrupt("return", a);

              case 6:
                o = new Promise(function (u, d) {
                  var h = _this4.subscribe("REQUESTED_ENTITIES", function (y) {
                    s.every(function (T) {
                      return y.entities.find(function (m) {
                        return m.sys.id === T;
                      });
                    }) && (clearTimeout(E), u(y.entities), _this4.cleanupPromise(r), n.forEach(function (T) {
                      return _this4.cleanupPromise(T);
                    }), h());
                  }),
                      E = setTimeout(function () {
                    d(new Error("Request for entities timed out")), h();
                  }, _this4.timeoutDuration);

                  _this4.sendMessage("REQUEST_ENTITIES", {
                    entityIds: s,
                    entityType: t,
                    locale: _this4.locale
                  });
                });
                this.requestCache.set(r, o);
                n.forEach(function (u) {
                  _this4.requestCache.set(u, o);
                });
                _context5.next = 11;
                return o;

              case 11:
                _context5.sent.forEach(function (u) {
                  _this4.addEntity(u);
                });

                return _context5.abrupt("return", this.getEntitiesFromMap(t, n).resolved);

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function fetchEntity(_x5, _x6) {
        return _fetchEntity.apply(this, arguments);
      }

      return fetchEntity;
    }()
  }, {
    key: "fetchAsset",
    value: function () {
      var _fetchAsset2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(t) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return this.fetchAssets([t]);

              case 3:
                return _context6.abrupt("return", _context6.sent[0]);

              case 6:
                _context6.prev = 6;
                _context6.t0 = _context6["catch"](0);
                console.warn("Failed to request asset ".concat(t));
                return _context6.abrupt("return");

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 6]]);
      }));

      function fetchAsset(_x7) {
        return _fetchAsset2.apply(this, arguments);
      }

      return fetchAsset;
    }()
  }, {
    key: "fetchAssets",
    value: function fetchAssets(t) {
      return this.fetchEntity("Asset", t);
    }
  }, {
    key: "fetchEntry",
    value: function () {
      var _fetchEntry2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(t) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return this.fetchEntries([t]);

              case 3:
                return _context7.abrupt("return", _context7.sent[0]);

              case 6:
                _context7.prev = 6;
                _context7.t0 = _context7["catch"](0);
                console.warn("Failed to request entry ".concat(t), _context7.t0);
                return _context7.abrupt("return");

              case 10:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 6]]);
      }));

      function fetchEntry(_x8) {
        return _fetchEntry2.apply(this, arguments);
      }

      return fetchEntry;
    }()
  }, {
    key: "fetchEntries",
    value: function fetchEntries(t) {
      return this.fetchEntity("Entry", t);
    }
  }]);

  return xt;
}(Rt);

var ne = "Collection";

function H(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}

function he(e) {
  return "".concat(e).concat(ne);
}

function kt(e) {
  if (e.endsWith(ne)) return H(e.replace(ne, ""));
}

var P = "Asset";

function V(e) {
  return !!(e && typeof e == "object" && "sys" in e && e.sys.id);
}

var Z = {};

function me(e, t) {
  return Z[e] || (Z[e] = new xt({
    entities: [],
    sendMessage: t,
    subscribe: function subscribe(n, s) {
      var i = function i(r) {
        typeof r.data != "object" || !r.data || r.data.from === "live-preview" && r.data.method === n && s(r.data);
      };

      return window.addEventListener("message", i), function () {
        return window.removeEventListener("message", i);
      };
    },
    locale: e
  })), Z[e];
}

function fe(_x9) {
  return _fe.apply(this, arguments);
}

function _fe() {
  _fe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(_ref5) {
    var e, t, n, s, i, o, l, u, r, d, a;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            e = _ref5.entityReferenceMap, t = _ref5.referenceId, n = _ref5.isAsset, s = _ref5.locale, i = _ref5.sendMessage;
            r = e.get(t);

            if (!r) {
              _context14.next = 4;
              break;
            }

            return _context14.abrupt("return", {
              reference: r,
              typeName: "contentType" in r.sys && (u = (l = (o = r.sys) == null ? void 0 : o.contentType) == null ? void 0 : l.sys) != null && u.id ? H(r.sys.contentType.sys.id) : P
            });

          case 4:
            if (!n) {
              _context14.next = 11;
              break;
            }

            _context14.next = 7;
            return me(s, i).fetchAsset(t);

          case 7:
            d = _context14.sent;

            if (d) {
              _context14.next = 10;
              break;
            }

            throw new Error("Unknown reference ".concat(t));

          case 10:
            return _context14.abrupt("return", {
              reference: d,
              typeName: P
            });

          case 11:
            _context14.next = 13;
            return me(s, i).fetchEntry(t);

          case 13:
            a = _context14.sent;

            if (a) {
              _context14.next = 16;
              break;
            }

            throw new Error("Unknown reference ".concat(t));

          case 16:
            return _context14.abrupt("return", {
              reference: a,
              typeName: H(a.sys.contentType.sys.id)
            });

          case 17:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _fe.apply(this, arguments);
}

function wt(e) {
  return typeof e.data != "object" || !e.data ? !1 : "from" in e.data && e.data.from === "live-preview" || "source" in e.data && e.data.source === Dt;
}

var N = /* @__PURE__ */function (e) {
  return e.FIELD_ID = "data-contentful-field-id", e.ENTRY_ID = "data-contentful-entry-id", e.ASSET_ID = "data-contentful-asset-id", e.LOCALE = "data-contentful-locale", e;
}(N || {}),
    C = /* @__PURE__ */function (e) {
  return e.MOUSE_MOVE = "MOUSE_MOVE", e.SCROLL_START = "SCROLL_START", e.SCROLL_END = "SCROLL_END", e.RESIZE_START = "RESIZE_START", e.RESIZE_END = "RESIZE_END", e.TAGGED_ELEMENTS = "TAGGED_ELEMENTS", e.INSPECTOR_MODE_CHANGED = "INSPECTOR_MODE_CHANGED", e;
}(C || {}),
    Pe = {
  0: 8203,
  1: 8204,
  2: 8205,
  3: 8290,
  4: 8291,
  5: 8288,
  6: 65279,
  7: 8289,
  8: 119155,
  9: 119156,
  a: 119157,
  b: 119158,
  c: 119159,
  d: 119160,
  e: 119161,
  f: 119162
},
    Ge = {
  0: 8203,
  1: 8204,
  2: 8205,
  3: 65279
},
    Bt = new Array(4).fill(String.fromCodePoint(Ge[0])).join(""),
    Oe = "\0",
    Mt = Object.fromEntries(Object.entries(Ge).map(function (e) {
  return e.reverse();
})),
    Se = Object.fromEntries(Object.entries(Pe).map(function (e) {
  return e.reverse();
})),
    Ut = "".concat(Object.values(Pe).map(function (e) {
  return "\\u{".concat(e.toString(16), "}");
}).join("")),
    Ft = new RegExp("[".concat(Ut, "]{4,}"), "gu");

function Pt(e) {
  var t = e.match(Ft);
  if (t) return Gt(t[0], !0)[0];
}

function Gt(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  var n = Array.from(e);

  if (n.length % 2 === 0) {
    if (n.length % 4 || !e.startsWith(Bt)) return Vt(n, t);
  } else throw new Error("Encoded data has invalid length");

  var s = [];

  for (var i = n.length * 0.25; i--;) {
    var r = n.slice(i * 4, i * 4 + 4).map(function (a) {
      return Mt[a.codePointAt(0)];
    }).join("");
    s.unshift(String.fromCharCode(parseInt(r, 4)));
  }

  if (t) {
    s.shift();

    var _i = s.indexOf(Oe);

    return _i === -1 && (_i = s.length), [JSON.parse(s.slice(0, _i).join(""))];
  }

  return s.join("").split(Oe).filter(Boolean).map(function (i) {
    return JSON.parse(i);
  });
}

function Vt(e, t) {
  var n;
  var s = [];

  for (var o = e.length * 0.5; o--;) {
    var l = "".concat(Se[e[o * 2].codePointAt(0)]).concat(Se[e[o * 2 + 1].codePointAt(0)]);
    s.unshift(String.fromCharCode(parseInt(l, 16)));
  }

  var i = [],
      r = [s.join("")],
      a = 10;

  for (; r.length;) {
    var _o = r.shift();

    try {
      if (i.push(JSON.parse(_o)), t) return i;
    } catch (l) {
      if (!a--) throw l;
      var u = +((n = l.message.match(/\sposition\s(\d+)$/)) == null ? void 0 : n[1]);
      if (!u) throw l;
      r.unshift(_o.substring(0, u), _o.substring(u));
    }
  }

  return i;
}

function De(e) {
  return Pt(e);
}

var ie = function ie(e) {
  if (!e || e.nodeType !== Node.ELEMENT_NODE) return !1;
  var t = e;
  return !(!t.hasAttribute(N.FIELD_ID) || !t.hasAttribute(N.ENTRY_ID) && !t.hasAttribute(N.ASSET_ID));
};

function jt(e, t) {
  var _e$getAttribute;

  if (!ie(e)) return null;
  var n = e.getAttribute(N.FIELD_ID),
      s = (_e$getAttribute = e.getAttribute(N.LOCALE)) !== null && _e$getAttribute !== void 0 ? _e$getAttribute : t,
      i = e.getAttribute(N.ENTRY_ID),
      r = e.getAttribute(N.ASSET_ID);
  return i ? {
    entryId: i,
    fieldId: n,
    locale: s
  } : r ? {
    assetId: r,
    fieldId: n,
    locale: s
  } : null;
}

function se() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
  var t = arguments.length > 1 ? arguments[1] : undefined;
  var n = document.createTreeWalker(e, NodeFilter.SHOW_ALL, function (i) {
    if (i.nodeType === Node.TEXT_NODE) {
      var _i$textContent;

      var r = (_i$textContent = i.textContent) !== null && _i$textContent !== void 0 ? _i$textContent : "",
          a = De(r);
      return (a == null ? void 0 : a.origin) !== "contentful.com" ? NodeFilter.FILTER_SKIP : ie(i.parentElement) ? t ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
    }

    return t ? NodeFilter.FILTER_SKIP : ie(i) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
  }),
      s = [];

  for (; n.nextNode();) {
    var i = n.currentNode;

    if (i.nodeType === Node.ELEMENT_NODE) {
      s.push(n.currentNode);
      continue;
    }

    if (!i.textContent) continue;
    var r = De(i.textContent);
    if (!(r != null && r.contentful)) continue;
    var a = r.contentful,
        o = i.parentElement;
    o && (a.entityType === "Entry" ? o.setAttribute(N.ENTRY_ID, a.entity) : o.setAttribute(N.ASSET_ID, a.entity), o.setAttribute(N.LOCALE, a.locale), o.setAttribute(N.FIELD_ID, a.field), s.push(o));
  }

  return s;
}

function Ve() {
  return _toConsumableArray(new Set(se().map(function (e) {
    return e.getAttribute(N.ENTRY_ID);
  }).filter(Boolean)));
}

var Kt = function Kt(t) {
  var _this5 = this;

  _classCallCheck(this, Kt);

  p(this, "isScrolling", !1);
  p(this, "scrollTimeout");
  p(this, "isResizing", !1);
  p(this, "resizeTimeout");
  p(this, "hoveredElement");
  p(this, "taggedElements", []);
  p(this, "taggedElementMutationObserver"); // Handles incoming messages from Contentful

  p(this, "receiveMessage", function (t) {
    if (t.method === C.INSPECTOR_MODE_CHANGED) {
      var n = t.isInspectorActive;
      n && _this5.sendAllElements();
    }
  });
  /** Checks if the hovered element is an tagged entry and then sends it to the editor */

  p(this, "addHoverListener", function () {
    var t = function t(n) {
      var s = n.composedPath();

      var _iterator3 = _createForOfIteratorHelper(s),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var i = _step3.value;
          var r = i;
          if (r.nodeName === "BODY") break;
          if (typeof (r == null ? void 0 : r.getAttribute) == "function" && _this5.handleTaggedElement(r)) return;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      _this5.hoveredElement && (_this5.hoveredElement = void 0, g(C.MOUSE_MOVE, {
        element: null
      }, _this5.options.targetOrigin));
    };

    return window.addEventListener("mouseover", t), function () {
      return window.removeEventListener("mouseover", t);
    };
  });
  /** Sends scroll start and end event to the editor, on end it also sends the tagged elements again */

  p(this, "addScrollListener", function () {
    var t = _this5.options.targetOrigin,
        n = function n() {
      _this5.isScrolling || (_this5.isScrolling = !0, g(C.SCROLL_START, {}, t)), _this5.scrollTimeout && clearTimeout(_this5.scrollTimeout), _this5.scrollTimeout = setTimeout(function () {
        _this5.isScrolling = !1, g(C.SCROLL_END, {}, t), _this5.sendAllElements(), _this5.hoveredElement && _this5.handleTaggedElement(_this5.hoveredElement);
      }, 150);
    };

    return window.addEventListener("scroll", n), function () {
      return window.removeEventListener("scroll", n);
    };
  });
  /** Detects DOM changes and sends the tagged elements to the editor */

  p(this, "addMutationListener", function () {
    var t = new MutationObserver(function () {
      var s;
      var n = se();
      ((s = _this5.taggedElements) == null ? void 0 : s.length) !== n.length && _this5.sendAllElements();
    });
    return t.observe(document.body, {
      attributes: !0,
      attributeFilter: [N.ENTRY_ID, N.FIELD_ID, N.LOCALE],
      childList: !0,
      subtree: !0
    }), function () {
      return t.disconnect();
    };
  });
  /** Sends resize start and end event to the editor, on end it also sends the tagged elements again */

  p(this, "addResizeListener", function () {
    var t = _this5.options.targetOrigin,
        n = new ResizeObserver(function () {
      _this5.isResizing || (_this5.isResizing = !0, g(C.RESIZE_START, {}, t)), _this5.resizeTimeout && clearTimeout(_this5.resizeTimeout), _this5.resizeTimeout = setTimeout(function () {
        _this5.isResizing = !1, g(C.RESIZE_END, {}, t), _this5.sendAllElements(), _this5.hoveredElement && _this5.handleTaggedElement(_this5.hoveredElement);
      }, 150);
    });
    return n.observe(document.body), function () {
      return n.disconnect();
    };
  });
  /**
   * Validates if the element has the inspector mode attributes
   * and sends it then to the editor
   */

  p(this, "handleTaggedElement", function (t) {
    var _this5$options = _this5.options,
        n = _this5$options.targetOrigin,
        s = _this5$options.locale,
        i = jt(t, s);
    return i ? (_this5.hoveredElement = t, g(C.MOUSE_MOVE, {
      element: {
        attributes: i,
        coordinates: t.getBoundingClientRect()
      }
    }, n), !0) : !1;
  });
  /**
   * Finds all elements that have all inspector mode attributes
   * and sends them to the editor
   */

  p(this, "sendAllElements", function () {
    var t = _this5.options.targetOrigin,
        n = se();
    _this5.taggedElements = n, _this5.taggedElementMutationObserver && _this5.taggedElementMutationObserver.disconnect();

    var s = function s() {
      g(C.TAGGED_ELEMENTS, {
        elements: n.map(function (i) {
          return {
            coordinates: i.getBoundingClientRect()
          };
        })
      }, t);
    };

    _this5.taggedElementMutationObserver = new MutationObserver(s), _this5.taggedElements.forEach(function (i) {
      var r;
      (r = _this5.taggedElementMutationObserver) == null || r.observe(i, {
        attributes: !0,
        attributeFilter: [N.ENTRY_ID, N.FIELD_ID, N.LOCALE],
        childList: !0,
        subtree: !0,
        characterData: !0
      });
    }), s();
  });
  this.options = t, this.addHoverListener(), this.addScrollListener(), this.addMutationListener(), this.addResizeListener();
};

var S = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};

function Zn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}

var A = {},
    R = {};
Object.defineProperty(R, "__esModule", {
  value: !0
});
R.BLOCKS = void 0;
var ge;

(function (e) {
  e.DOCUMENT = "document", e.PARAGRAPH = "paragraph", e.HEADING_1 = "heading-1", e.HEADING_2 = "heading-2", e.HEADING_3 = "heading-3", e.HEADING_4 = "heading-4", e.HEADING_5 = "heading-5", e.HEADING_6 = "heading-6", e.OL_LIST = "ordered-list", e.UL_LIST = "unordered-list", e.LIST_ITEM = "list-item", e.HR = "hr", e.QUOTE = "blockquote", e.EMBEDDED_ENTRY = "embedded-entry-block", e.EMBEDDED_ASSET = "embedded-asset-block", e.EMBEDDED_RESOURCE = "embedded-resource-block", e.TABLE = "table", e.TABLE_ROW = "table-row", e.TABLE_CELL = "table-cell", e.TABLE_HEADER_CELL = "table-header-cell";
})(ge || (R.BLOCKS = ge = {}));

var w = {};
Object.defineProperty(w, "__esModule", {
  value: !0
});
w.INLINES = void 0;
var Ae;

(function (e) {
  e.HYPERLINK = "hyperlink", e.ENTRY_HYPERLINK = "entry-hyperlink", e.ASSET_HYPERLINK = "asset-hyperlink", e.RESOURCE_HYPERLINK = "resource-hyperlink", e.EMBEDDED_ENTRY = "embedded-entry-inline", e.EMBEDDED_RESOURCE = "embedded-resource-inline";
})(Ae || (w.INLINES = Ae = {}));

var z = {};
Object.defineProperty(z, "__esModule", {
  value: !0
});
var re;

(function (e) {
  e.BOLD = "bold", e.ITALIC = "italic", e.UNDERLINE = "underline", e.CODE = "code", e.SUPERSCRIPT = "superscript", e.SUBSCRIPT = "subscript";
})(re || (re = {}));

z.default = re;
var je = {};

(function (e) {
  var t = S && S.__spreadArray || function (o, l, u) {
    if (u || arguments.length === 2) for (var d = 0, h = l.length, E; d < h; d++) {
      (E || !(d in l)) && (E || (E = Array.prototype.slice.call(l, 0, d)), E[d] = l[d]);
    }
    return o.concat(E || Array.prototype.slice.call(l));
  },
      n = S && S.__importDefault || function (o) {
    return o && o.__esModule ? o : {
      default: o
    };
  },
      s;

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.V1_MARKS = e.V1_NODE_TYPES = e.TEXT_CONTAINERS = e.HEADINGS = e.CONTAINERS = e.VOID_BLOCKS = e.TABLE_BLOCKS = e.LIST_ITEM_BLOCKS = e.TOP_LEVEL_BLOCKS = void 0;
  var i = R,
      r = w,
      a = n(z);
  e.TOP_LEVEL_BLOCKS = [i.BLOCKS.PARAGRAPH, i.BLOCKS.HEADING_1, i.BLOCKS.HEADING_2, i.BLOCKS.HEADING_3, i.BLOCKS.HEADING_4, i.BLOCKS.HEADING_5, i.BLOCKS.HEADING_6, i.BLOCKS.OL_LIST, i.BLOCKS.UL_LIST, i.BLOCKS.HR, i.BLOCKS.QUOTE, i.BLOCKS.EMBEDDED_ENTRY, i.BLOCKS.EMBEDDED_ASSET, i.BLOCKS.EMBEDDED_RESOURCE, i.BLOCKS.TABLE], e.LIST_ITEM_BLOCKS = [i.BLOCKS.PARAGRAPH, i.BLOCKS.HEADING_1, i.BLOCKS.HEADING_2, i.BLOCKS.HEADING_3, i.BLOCKS.HEADING_4, i.BLOCKS.HEADING_5, i.BLOCKS.HEADING_6, i.BLOCKS.OL_LIST, i.BLOCKS.UL_LIST, i.BLOCKS.HR, i.BLOCKS.QUOTE, i.BLOCKS.EMBEDDED_ENTRY, i.BLOCKS.EMBEDDED_ASSET, i.BLOCKS.EMBEDDED_RESOURCE], e.TABLE_BLOCKS = [i.BLOCKS.TABLE, i.BLOCKS.TABLE_ROW, i.BLOCKS.TABLE_CELL, i.BLOCKS.TABLE_HEADER_CELL], e.VOID_BLOCKS = [i.BLOCKS.HR, i.BLOCKS.EMBEDDED_ENTRY, i.BLOCKS.EMBEDDED_ASSET, i.BLOCKS.EMBEDDED_RESOURCE], e.CONTAINERS = (s = {}, s[i.BLOCKS.OL_LIST] = [i.BLOCKS.LIST_ITEM], s[i.BLOCKS.UL_LIST] = [i.BLOCKS.LIST_ITEM], s[i.BLOCKS.LIST_ITEM] = e.LIST_ITEM_BLOCKS, s[i.BLOCKS.QUOTE] = [i.BLOCKS.PARAGRAPH], s[i.BLOCKS.TABLE] = [i.BLOCKS.TABLE_ROW], s[i.BLOCKS.TABLE_ROW] = [i.BLOCKS.TABLE_CELL, i.BLOCKS.TABLE_HEADER_CELL], s[i.BLOCKS.TABLE_CELL] = [i.BLOCKS.PARAGRAPH], s[i.BLOCKS.TABLE_HEADER_CELL] = [i.BLOCKS.PARAGRAPH], s), e.HEADINGS = [i.BLOCKS.HEADING_1, i.BLOCKS.HEADING_2, i.BLOCKS.HEADING_3, i.BLOCKS.HEADING_4, i.BLOCKS.HEADING_5, i.BLOCKS.HEADING_6], e.TEXT_CONTAINERS = t([i.BLOCKS.PARAGRAPH], e.HEADINGS, !0), e.V1_NODE_TYPES = [i.BLOCKS.DOCUMENT, i.BLOCKS.PARAGRAPH, i.BLOCKS.HEADING_1, i.BLOCKS.HEADING_2, i.BLOCKS.HEADING_3, i.BLOCKS.HEADING_4, i.BLOCKS.HEADING_5, i.BLOCKS.HEADING_6, i.BLOCKS.OL_LIST, i.BLOCKS.UL_LIST, i.BLOCKS.LIST_ITEM, i.BLOCKS.HR, i.BLOCKS.QUOTE, i.BLOCKS.EMBEDDED_ENTRY, i.BLOCKS.EMBEDDED_ASSET, r.INLINES.HYPERLINK, r.INLINES.ENTRY_HYPERLINK, r.INLINES.ASSET_HYPERLINK, r.INLINES.EMBEDDED_ENTRY, "text"], e.V1_MARKS = [a.default.BOLD, a.default.CODE, a.default.ITALIC, a.default.UNDERLINE];
})(je);

var Ke = {};
Object.defineProperty(Ke, "__esModule", {
  value: !0
});
var Ye = {};
Object.defineProperty(Ye, "__esModule", {
  value: !0
});
var Ee = {};
Object.defineProperty(Ee, "__esModule", {
  value: !0
});
var Le = R,
    Yt = {
  nodeType: Le.BLOCKS.DOCUMENT,
  data: {},
  content: [{
    nodeType: Le.BLOCKS.PARAGRAPH,
    data: {},
    content: [{
      nodeType: "text",
      value: "",
      marks: [],
      data: {}
    }]
  }]
};
Ee.default = Yt;
var b = {};
Object.defineProperty(b, "__esModule", {
  value: !0
});
b.isText = b.isBlock = b.isInline = void 0;
var Ht = R,
    $t = w;

function He(e, t) {
  for (var n = 0, s = Object.keys(e); n < s.length; n++) {
    var i = s[n];
    if (t === e[i]) return !0;
  }

  return !1;
}

function Qt(e) {
  return He($t.INLINES, e.nodeType);
}

b.isInline = Qt;

function zt(e) {
  return He(Ht.BLOCKS, e.nodeType);
}

b.isBlock = zt;

function Jt(e) {
  return e.nodeType === "text";
}

b.isText = Jt;

(function (e) {
  var t = S && S.__createBinding || (Object.create ? function (h, E, y, T) {
    T === void 0 && (T = y);
    var m = Object.getOwnPropertyDescriptor(E, y);
    (!m || ("get" in m ? !E.__esModule : m.writable || m.configurable)) && (m = {
      enumerable: !0,
      get: function get() {
        return E[y];
      }
    }), Object.defineProperty(h, T, m);
  } : function (h, E, y, T) {
    T === void 0 && (T = y), h[T] = E[y];
  }),
      n = S && S.__setModuleDefault || (Object.create ? function (h, E) {
    Object.defineProperty(h, "default", {
      enumerable: !0,
      value: E
    });
  } : function (h, E) {
    h.default = E;
  }),
      s = S && S.__exportStar || function (h, E) {
    for (var y in h) {
      y !== "default" && !Object.prototype.hasOwnProperty.call(E, y) && t(E, h, y);
    }
  },
      i = S && S.__importStar || function (h) {
    if (h && h.__esModule) return h;
    var E = {};
    if (h != null) for (var y in h) {
      y !== "default" && Object.prototype.hasOwnProperty.call(h, y) && t(E, h, y);
    }
    return n(E, h), E;
  },
      r = S && S.__importDefault || function (h) {
    return h && h.__esModule ? h : {
      default: h
    };
  };

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.helpers = e.EMPTY_DOCUMENT = e.MARKS = e.INLINES = e.BLOCKS = void 0;
  var a = R;
  Object.defineProperty(e, "BLOCKS", {
    enumerable: !0,
    get: function get() {
      return a.BLOCKS;
    }
  });
  var o = w;
  Object.defineProperty(e, "INLINES", {
    enumerable: !0,
    get: function get() {
      return o.INLINES;
    }
  });
  var l = z;
  Object.defineProperty(e, "MARKS", {
    enumerable: !0,
    get: function get() {
      return r(l).default;
    }
  }), s(je, e), s(Ke, e), s(Ye, e);
  var u = Ee;
  Object.defineProperty(e, "EMPTY_DOCUMENT", {
    enumerable: !0,
    get: function get() {
      return r(u).default;
    }
  });
  var d = i(b);
  e.helpers = d;
})(A);

function Ce(e) {
  return !e || typeof e != "object" || !("sys" in e) ? !1 : e.sys.type !== "ResourceLink";
}

function be(e) {
  return !e || typeof e != "object" || !("sys" in e) ? !1 : e.sys.type === "ResourceLink";
}

function pe(e) {
  if (!e || typeof e != "object") return !1;
  var t = e;
  return t.content && t.nodeType === A.BLOCKS.DOCUMENT;
}

var $e = [A.BLOCKS.EMBEDDED_ENTRY, A.BLOCKS.EMBEDDED_ASSET, A.INLINES.EMBEDDED_ENTRY, A.INLINES.ENTRY_HYPERLINK, A.INLINES.ASSET_HYPERLINK];

function Qe(e) {
  return e.sys && "linkType" in e.sys && e.sys.linkType === P;
}

function qt(e, t) {
  return e.name.value === "items" && kt(t) || e.name.value;
}

function ze(e, t) {
  var s, i;
  var n = [];

  var _iterator4 = _createForOfIteratorHelper(e),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var r = _step4.value;
      r.kind === "Field" && (n.push({
        name: r.name.value,
        alias: (s = r.alias) == null ? void 0 : s.value,
        __typename: t
      }), (i = r.selectionSet) != null && i.selections && n.push.apply(n, _toConsumableArray(ze(r.selectionSet.selections, qt(r, t)))));
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return n;
}

function Wt(e) {
  var s;
  var t = [];

  var _iterator5 = _createForOfIteratorHelper(e.definitions),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var _i3 = _step5.value;

      if (_i3.kind === "OperationDefinition" || _i3.kind === "FragmentDefinition") {
        var _r = "typeCondition" in _i3 ? _i3.typeCondition.name.value : (s = _i3.name) == null ? void 0 : s.value;

        if (!_r) {
          _.warn("Could not generate __typename for query definition", _i3);

          continue;
        }

        var _iterator6 = _createForOfIteratorHelper(_i3.selectionSet.selections),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var _a = _step6.value;
            _a.kind === "Field" && t.push.apply(t, _toConsumableArray(ze(_i3.selectionSet.selections, _r)));
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  var n = /* @__PURE__ */new Map();

  for (var _i2 = 0, _t3 = t; _i2 < _t3.length; _i2++) {
    var _t3$_i = _t3[_i2],
        i = _t3$_i.__typename,
        r = _t3$_i.alias,
        a = _t3$_i.name;
    var o = n.get(i) || {
      alias: /* @__PURE__ */new Map(),
      fields: /* @__PURE__ */new Set()
    };
    o.fields.add(a), r && o.alias.set(a, r), n.set(i, o);
  }

  return n;
}

function Je(e, t, n) {
  if (!n) return !0;
  var s = n.get(t);
  return s ? s.fields.has(e) || s.fields.has(he(e)) : !1;
}

function Te(e, t, n) {
  var i;
  var s = (i = n == null ? void 0 : n.get(t)) == null ? void 0 : i.alias;
  if (!s) return e;

  for (var r in e) {
    var a = s == null ? void 0 : s.get(r);
    a !== r && (e[a] = e[r]);
  }

  return e;
}

function qe(e, t, n) {
  var s, i;

  try {
    var r = t.fields.file,
        a = r == null ? void 0 : r.details,
        o = _objectSpread(_objectSpread({}, e), {}, {
      // GraphQL flattens some information
      // and as the live updates are coming from the CMA, we need to transform them
      title: t.fields.title,
      description: t.fields.description,
      contentType: r == null ? void 0 : r.contentType,
      url: Lt(r == null ? void 0 : r.url),
      // Note: video has no `width` and `height`
      width: (s = a == null ? void 0 : a.image) == null ? void 0 : s.width,
      height: (i = a == null ? void 0 : a.image) == null ? void 0 : i.height
    });

    return Te(o, P, n);
  } catch (r) {
    return _.warn("Failed update asset", {
      dataFromPreviewApp: e,
      updateFromEntryEditor: t
    }, r), e;
  }
}

function Xt(_x10) {
  return _Xt.apply(this, arguments);
}

function _Xt() {
  _Xt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(_ref6) {
    var e, t, n, s, i, r, a, u, o, l, _iterator12, _step12, _d$apiName, d, h;

    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            e = _ref6.contentType, t = _ref6.dataFromPreviewApp, n = _ref6.updateFromEntryEditor, s = _ref6.locale, i = _ref6.entityReferenceMap, r = _ref6.gqlParams, a = _ref6.sendMessage;

            if (!(t.sys.id !== n.sys.id)) {
              _context15.next = 3;
              break;
            }

            return _context15.abrupt("return", t);

          case 3:
            o = de(t), l = H(e.sys.id);
            _iterator12 = _createForOfIteratorHelper(e.fields);
            _context15.prev = 5;

            _iterator12.s();

          case 7:
            if ((_step12 = _iterator12.n()).done) {
              _context15.next = 32;
              break;
            }

            d = _step12.value;
            h = (_d$apiName = d.apiName) !== null && _d$apiName !== void 0 ? _d$apiName : d.name;
            _context15.t0 = Je(h, l, r);

            if (!_context15.t0) {
              _context15.next = 30;
              break;
            }

            if (!Ue(d)) {
              _context15.next = 16;
              break;
            }

            ue({
              dataFromPreviewApp: o,
              updateFromEntryEditor: n,
              name: h
            });
            _context15.next = 30;
            break;

          case 16:
            if (!(d.type === "RichText")) {
              _context15.next = 21;
              break;
            }

            _context15.next = 19;
            return Zt({
              dataFromPreviewApp: o,
              updateFromEntryEditor: n,
              entityReferenceMap: i,
              name: h,
              locale: s,
              gqlParams: r,
              sendMessage: a
            });

          case 19:
            _context15.next = 30;
            break;

          case 21:
            if (!(d.type === "Link")) {
              _context15.next = 26;
              break;
            }

            _context15.next = 24;
            return nt({
              dataFromPreviewApp: o,
              updateFromEntryEditor: n,
              name: h,
              locale: s,
              entityReferenceMap: i,
              gqlParams: r,
              sendMessage: a
            });

          case 24:
            _context15.next = 30;
            break;

          case 26:
            _context15.t1 = d.type === "Array" && ((u = d.items) == null ? void 0 : u.type) === "Link";

            if (!_context15.t1) {
              _context15.next = 30;
              break;
            }

            _context15.next = 30;
            return it({
              dataFromPreviewApp: o,
              updateFromEntryEditor: n,
              name: h,
              locale: s,
              entityReferenceMap: i,
              gqlParams: r,
              sendMessage: a
            });

          case 30:
            _context15.next = 7;
            break;

          case 32:
            _context15.next = 37;
            break;

          case 34:
            _context15.prev = 34;
            _context15.t2 = _context15["catch"](5);

            _iterator12.e(_context15.t2);

          case 37:
            _context15.prev = 37;

            _iterator12.f();

            return _context15.finish(37);

          case 40:
            return _context15.abrupt("return", Te(o, l, r));

          case 41:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15, null, [[5, 34, 37, 40]]);
  }));
  return _Xt.apply(this, arguments);
}

function ve(e) {
  return Object.values(e).every(function (t) {
    return t.length === 0;
  });
}

function We(_x11, _x12, _x13, _x14, _x15, _x16, _x17) {
  return _We.apply(this, arguments);
}

function _We() {
  _We = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(e, t, n, s, i, r, a) {
    var o, l, _iterator13, _step13, _o2;

    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            if (!$e.includes(e.nodeType)) {
              _context16.next = 31;
              break;
            }

            if (!(e.data && e.data.target && e.data.target.sys)) {
              _context16.next = 29;
              break;
            }

            o = {
              sys: _objectSpread(_objectSpread({}, e.data.target.sys), {}, {
                type: "Link",
                linkType: e.data.target.sys.type
              })
            };

            if (!(e.data.target.sys.linkType === "Entry")) {
              _context16.next = 9;
              break;
            }

            _context16.next = 6;
            return et({
              referenceFromPreviewApp: null,
              updatedReference: o,
              entityReferenceMap: s,
              locale: i,
              gqlParams: a,
              sendMessage: r
            });

          case 6:
            l = _context16.sent;
            _context16.next = 14;
            break;

          case 9:
            _context16.t0 = e.data.target.sys.linkType === "Asset";

            if (!_context16.t0) {
              _context16.next = 14;
              break;
            }

            _context16.next = 13;
            return Ze({
              referenceFromPreviewApp: null,
              updatedReference: o,
              entityReferenceMap: s,
              locale: i,
              gqlParams: a,
              sendMessage: r
            });

          case 13:
            l = _context16.sent;

          case 14:
            if (!l) {
              _context16.next = 29;
              break;
            }

            _context16.t1 = e.nodeType;
            _context16.next = _context16.t1 === A.BLOCKS.EMBEDDED_ENTRY ? 18 : _context16.t1 === A.BLOCKS.EMBEDDED_ASSET ? 20 : _context16.t1 === A.INLINES.EMBEDDED_ENTRY ? 22 : _context16.t1 === A.INLINES.ENTRY_HYPERLINK ? 24 : _context16.t1 === A.INLINES.ASSET_HYPERLINK ? 26 : 28;
            break;

          case 18:
            t.block.push(l);
            return _context16.abrupt("break", 29);

          case 20:
            n.block.push(l);
            return _context16.abrupt("break", 29);

          case 22:
            t.inline.push(l);
            return _context16.abrupt("break", 29);

          case 24:
            t.hyperlink.push(l);
            return _context16.abrupt("break", 29);

          case 26:
            n.hyperlink.push(l);
            return _context16.abrupt("break", 29);

          case 28:
            _.warn("Unhandled nodeType in embedded entries in rich text", {
              nodeType: e.nodeType,
              ref: l
            });

          case 29:
            _context16.next = 49;
            break;

          case 31:
            if (!e.content) {
              _context16.next = 49;
              break;
            }

            _iterator13 = _createForOfIteratorHelper(e.content);
            _context16.prev = 33;

            _iterator13.s();

          case 35:
            if ((_step13 = _iterator13.n()).done) {
              _context16.next = 41;
              break;
            }

            _o2 = _step13.value;
            _context16.next = 39;
            return We(_o2, t, n, s, i, r, a);

          case 39:
            _context16.next = 35;
            break;

          case 41:
            _context16.next = 46;
            break;

          case 43:
            _context16.prev = 43;
            _context16.t2 = _context16["catch"](33);

            _iterator13.e(_context16.t2);

          case 46:
            _context16.prev = 46;

            _iterator13.f();

            return _context16.finish(46);

          case 49:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16, null, [[33, 43, 46, 49]]);
  }));
  return _We.apply(this, arguments);
}

function Xe(_x18, _x19, _x20, _x21, _x22) {
  return _Xe.apply(this, arguments);
}

function _Xe() {
  _Xe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(e, t, n, s, i) {
    var r, a, _iterator14, _step14, o;

    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            r = {
              block: [],
              inline: [],
              hyperlink: []
            }, a = {
              block: [],
              inline: [],
              hyperlink: []
            };

            if (!e) {
              _context17.next = 19;
              break;
            }

            _iterator14 = _createForOfIteratorHelper(e.content);
            _context17.prev = 3;

            _iterator14.s();

          case 5:
            if ((_step14 = _iterator14.n()).done) {
              _context17.next = 11;
              break;
            }

            o = _step14.value;
            _context17.next = 9;
            return We(o, r, a, t, n, s, i);

          case 9:
            _context17.next = 5;
            break;

          case 11:
            _context17.next = 16;
            break;

          case 13:
            _context17.prev = 13;
            _context17.t0 = _context17["catch"](3);

            _iterator14.e(_context17.t0);

          case 16:
            _context17.prev = 16;

            _iterator14.f();

            return _context17.finish(16);

          case 19:
            return _context17.abrupt("return", {
              entries: ve(r) ? {
                block: [],
                inline: [],
                hyperlink: []
              } : r,
              assets: ve(a) ? {
                block: [],
                inline: [],
                hyperlink: []
              } : a
            });

          case 20:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17, null, [[3, 13, 16, 19]]);
  }));
  return _Xe.apply(this, arguments);
}

function Zt(_x23) {
  return _Zt.apply(this, arguments);
}

function _Zt() {
  _Zt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(_ref7) {
    var e, t, n, s, i, r, a, o;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            e = _ref7.dataFromPreviewApp, t = _ref7.updateFromEntryEditor, n = _ref7.name, s = _ref7.locale, i = _ref7.entityReferenceMap, r = _ref7.gqlParams, a = _ref7.sendMessage;
            e[n] || (e[n] = {});
            e[n].json = ((o = t == null ? void 0 : t.fields) == null ? void 0 : o[n]) || null;
            _context18.next = 5;
            return Xe(e[n].json, i, s, a, r);

          case 5:
            e[n].links = _context18.sent;

          case 6:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));
  return _Zt.apply(this, arguments);
}

function Ze(_x24) {
  return _Ze.apply(this, arguments);
}

function _Ze() {
  _Ze = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(_ref8) {
    var e, t, n, s, i, r, _yield$fe, a;

    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            e = _ref8.referenceFromPreviewApp, t = _ref8.updatedReference, n = _ref8.entityReferenceMap, s = _ref8.locale, i = _ref8.gqlParams, r = _ref8.sendMessage;
            _context19.next = 3;
            return fe({
              entityReferenceMap: n,
              referenceId: t.sys.id,
              isAsset: !0,
              locale: s,
              sendMessage: r
            });

          case 3:
            _yield$fe = _context19.sent;
            a = _yield$fe.reference;
            return _context19.abrupt("return", qe(_objectSpread(_objectSpread(_objectSpread({}, e), t), {}, {
              __typename: P
            }), a, i));

          case 6:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));
  return _Ze.apply(this, arguments);
}

function et(_x25) {
  return _et.apply(this, arguments);
}

function _et() {
  _et = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(_ref9) {
    var e, t, n, s, i, r, u, _yield$fe2, a, o, l, d, h, E;

    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            e = _ref9.referenceFromPreviewApp, t = _ref9.updatedReference, n = _ref9.entityReferenceMap, s = _ref9.locale, i = _ref9.gqlParams, r = _ref9.sendMessage;
            _context20.next = 3;
            return fe({
              entityReferenceMap: n,
              referenceId: t.sys.id,
              locale: s,
              sendMessage: r
            });

          case 3:
            _yield$fe2 = _context20.sent;
            a = _yield$fe2.reference;
            o = _yield$fe2.typeName;
            l = _objectSpread(_objectSpread(_objectSpread({}, e), t), {}, {
              __typename: o
            });
            _context20.t0 = _regeneratorRuntime.keys(a.fields);

          case 8:
            if ((_context20.t1 = _context20.t0()).done) {
              _context20.next = 37;
              break;
            }

            d = _context20.t1.value;

            if (Je(d, o, i)) {
              _context20.next = 12;
              break;
            }

            return _context20.abrupt("continue", 8);

          case 12:
            h = a.fields[d];

            if (!(h && typeof h == "object")) {
              _context20.next = 27;
              break;
            }

            _context20.t2 = pe(h);

            if (!_context20.t2) {
              _context20.next = 20;
              break;
            }

            l[d] = {
              json: h
            };
            _context20.next = 19;
            return Xe(h, n, s, r, i);

          case 19:
            l[d].links = _context20.sent;

          case 20:
            _context20.t3 = "sys" in h;

            if (!_context20.t3) {
              _context20.next = 25;
              break;
            }

            l[d] = h;
            _context20.next = 25;
            return nt({
              dataFromPreviewApp: l,
              updateFromEntryEditor: a,
              locale: s,
              entityReferenceMap: n,
              name: d,
              gqlParams: i,
              sendMessage: r
            });

          case 25:
            _context20.next = 35;
            break;

          case 27:
            if (!(Array.isArray(h) && (u = h[0]) != null && u.sys)) {
              _context20.next = 34;
              break;
            }

            E = he(d);
            l[E] = {
              items: h
            };
            _context20.next = 32;
            return it({
              dataFromPreviewApp: l,
              updateFromEntryEditor: a,
              locale: s,
              entityReferenceMap: n,
              name: d,
              gqlParams: i,
              sendMessage: r
            });

          case 32:
            _context20.next = 35;
            break;

          case 34:
            l[d] = h;

          case 35:
            _context20.next = 8;
            break;

          case 37:
            return _context20.abrupt("return", Te(l, o, i));

          case 38:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));
  return _et.apply(this, arguments);
}

function tt(_x26) {
  return _tt.apply(this, arguments);
}

function _tt() {
  _tt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(_ref10) {
    var e, t, n, s, i, r;
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            e = _ref10.referenceFromPreviewApp, t = _ref10.updatedReference, n = _ref10.entityReferenceMap, s = _ref10.locale, i = _ref10.gqlParams, r = _ref10.sendMessage;
            return _context21.abrupt("return", t ? e && e.__typename ? e : t.__typename ? t : Qe(t) ? Ze({
              referenceFromPreviewApp: e,
              updatedReference: t,
              entityReferenceMap: n,
              locale: s,
              gqlParams: i,
              sendMessage: r
            }) : et({
              referenceFromPreviewApp: e,
              updatedReference: t,
              entityReferenceMap: n,
              locale: s,
              gqlParams: i,
              sendMessage: r
            }) : null);

          case 2:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));
  return _tt.apply(this, arguments);
}

function nt(_x27) {
  return _nt.apply(this, arguments);
}

function _nt() {
  _nt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(_ref11) {
    var e, t, n, s, i, r, a, l, o;
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            e = _ref11.dataFromPreviewApp, t = _ref11.updateFromEntryEditor, n = _ref11.name, s = _ref11.locale, i = _ref11.entityReferenceMap, r = _ref11.gqlParams, a = _ref11.sendMessage;
            o = (l = t == null ? void 0 : t.fields) == null ? void 0 : l[n];
            _context22.next = 4;
            return tt({
              referenceFromPreviewApp: e[n],
              updatedReference: o,
              entityReferenceMap: i,
              locale: s,
              gqlParams: r,
              sendMessage: a
            });

          case 4:
            e[n] = _context22.sent;

          case 5:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22);
  }));
  return _nt.apply(this, arguments);
}

function it(_x28) {
  return _it.apply(this, arguments);
}

function _it() {
  _it = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(_ref12) {
    var e, t, n, s, i, r, a, d, o, l, u;
    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            e = _ref12.dataFromPreviewApp, t = _ref12.updateFromEntryEditor, n = _ref12.name, s = _ref12.locale, i = _ref12.entityReferenceMap, r = _ref12.gqlParams, a = _ref12.sendMessage;
            o = he(n);
            l = ((d = t == null ? void 0 : t.fields) == null ? void 0 : d[n]) || [];
            _context24.next = 5;
            return Promise.all(l.map( /*#__PURE__*/function () {
              var _ref31 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(h) {
                var T, m, E;
                return _regeneratorRuntime.wrap(function _callee23$(_context23) {
                  while (1) {
                    switch (_context23.prev = _context23.next) {
                      case 0:
                        E = (m = (T = e[o]) == null ? void 0 : T.items) == null ? void 0 : m.find(function (It) {
                          return It.sys.id === h.sys.id;
                        });
                        _context23.next = 3;
                        return tt({
                          referenceFromPreviewApp: E,
                          updatedReference: h,
                          entityReferenceMap: i,
                          locale: s,
                          gqlParams: r,
                          sendMessage: a
                        });

                      case 3:
                        return _context23.abrupt("return", _context23.sent);

                      case 4:
                      case "end":
                        return _context23.stop();
                    }
                  }
                }, _callee23);
              }));

              return function (_x83) {
                return _ref31.apply(this, arguments);
              };
            }()));

          case 5:
            u = _context24.sent;
            e[o] || (e[o] = {
              items: []
            }), e[o].items = u.filter(Boolean);

          case 7:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24);
  }));
  return _it.apply(this, arguments);
}

var _$ = function $() {
  return _$ = Object.assign || function (t) {
    for (var n, s = 1, i = arguments.length; s < i; s++) {
      n = arguments[s];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
      }
    }

    return t;
  }, _$.apply(this, arguments);
};

function ee(e, t) {
  if (!!!e) throw new Error(t);
}

function en(e) {
  return typeof e == "object" && e !== null;
}

function tn(e, t) {
  if (!!!e) throw new Error(t !== null && t !== void 0 ? t : "Unexpected invariant triggered.");
}

var nn = /\r\n|[\n\r]/g;

function ae(e, t) {
  var n = 0,
      s = 1;

  var _iterator7 = _createForOfIteratorHelper(e.body.matchAll(nn)),
      _step7;

  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var i = _step7.value;
      if (typeof i.index == "number" || tn(!1), i.index >= t) break;
      n = i.index + i[0].length, s += 1;
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }

  return {
    line: s,
    column: t + 1 - n
  };
}

function sn(e) {
  return st(e.source, ae(e.source, e.start));
}

function st(e, t) {
  var n = e.locationOffset.column - 1,
      s = "".padStart(n) + e.body,
      i = t.line - 1,
      r = e.locationOffset.line - 1,
      a = t.line + r,
      o = t.line === 1 ? n : 0,
      l = t.column + o,
      u = "".concat(e.name, ":").concat(a, ":").concat(l, "\n"),
      d = s.split(/\r\n|[\n\r]/g),
      h = d[i];

  if (h.length > 120) {
    var E = Math.floor(l / 80),
        y = l % 80,
        T = [];

    for (var m = 0; m < h.length; m += 80) {
      T.push(h.slice(m, m + 80));
    }

    return u + Re([["".concat(a, " |"), T[0]]].concat(_toConsumableArray(T.slice(1, E + 1).map(function (m) {
      return ["|", m];
    })), [["|", "^".padStart(y)], ["|", T[E + 1]]]));
  }

  return u + Re([// Lines specified like this: ["prefix", "string"],
  ["".concat(a - 1, " |"), d[i - 1]], ["".concat(a, " |"), h], ["|", "^".padStart(l)], ["".concat(a + 1, " |"), d[i + 1]]]);
}

function Re(e) {
  var t = e.filter(function (_ref13) {
    var _ref14 = _slicedToArray(_ref13, 2),
        s = _ref14[0],
        i = _ref14[1];

    return i !== void 0;
  }),
      n = Math.max.apply(Math, _toConsumableArray(t.map(function (_ref15) {
    var _ref16 = _slicedToArray(_ref15, 1),
        s = _ref16[0];

    return s.length;
  })));
  return t.map(function (_ref17) {
    var _ref18 = _slicedToArray(_ref17, 2),
        s = _ref18[0],
        i = _ref18[1];

    return s.padStart(n) + (i ? " " + i : "");
  }).join("\n");
}

function rn(e) {
  var t = e[0];
  return t == null || "kind" in t || "length" in t ? {
    nodes: t,
    source: e[1],
    positions: e[2],
    path: e[3],
    originalError: e[4],
    extensions: e[5]
  } : t;
}

var Ne = /*#__PURE__*/function (_Error, _Symbol$toStringTag) {
  _inherits(Ne, _Error);

  var _super2 = _createSuper(Ne);

  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */

  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */

  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */

  /**
   * The original error thrown from a field resolver during execution.
   */

  /**
   * Extension fields to add to the formatted error.
   */

  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  function Ne(t) {
    var _this6;

    _classCallCheck(this, Ne);

    var s, i, r;

    for (var _len2 = arguments.length, n = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      n[_key2 - 1] = arguments[_key2];
    }

    var _rn = rn(n),
        a = _rn.nodes,
        o = _rn.source,
        l = _rn.positions,
        u = _rn.path,
        d = _rn.originalError,
        h = _rn.extensions;

    _this6 = _super2.call(this, t), _this6.name = "GraphQLError", _this6.path = u !== null && u !== void 0 ? u : void 0, _this6.originalError = d !== null && d !== void 0 ? d : void 0, _this6.nodes = xe(Array.isArray(a) ? a : a ? [a] : void 0);
    var E = xe((s = _this6.nodes) === null || s === void 0 ? void 0 : s.map(function (T) {
      return T.loc;
    }).filter(function (T) {
      return T != null;
    }));
    _this6.source = o !== null && o !== void 0 ? o : E == null || (i = E[0]) === null || i === void 0 ? void 0 : i.source, _this6.positions = l !== null && l !== void 0 ? l : E == null ? void 0 : E.map(function (T) {
      return T.start;
    }), _this6.locations = l && o ? l.map(function (T) {
      return ae(o, T);
    }) : E == null ? void 0 : E.map(function (T) {
      return ae(T.source, T.start);
    });
    var y = en(d == null ? void 0 : d.extensions) ? d == null ? void 0 : d.extensions : void 0;
    _this6.extensions = (r = h !== null && h !== void 0 ? h : y) !== null && r !== void 0 ? r : /* @__PURE__ */Object.create(null), Object.defineProperties(_assertThisInitialized(_this6), {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), d != null && d.stack ? Object.defineProperty(_assertThisInitialized(_this6), "stack", {
      value: d.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(_assertThisInitialized(_this6), Ne) : Object.defineProperty(_assertThisInitialized(_this6), "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
    return _this6;
  }

  _createClass(Ne, [{
    key: _Symbol$toStringTag,
    get: function get() {
      return "GraphQLError";
    }
  }, {
    key: "toString",
    value: function toString() {
      var t = this.message;

      if (this.nodes) {
        var _iterator8 = _createForOfIteratorHelper(this.nodes),
            _step8;

        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var n = _step8.value;
            n.loc && (t += "\n\n" + sn(n.loc));
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }
      } else if (this.source && this.locations) {
        var _iterator9 = _createForOfIteratorHelper(this.locations),
            _step9;

        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var _n2 = _step9.value;
            t += "\n\n" + st(this.source, _n2);
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }
      }

      return t;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = {
        message: this.message
      };
      return this.locations != null && (t.locations = this.locations), this.path != null && (t.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (t.extensions = this.extensions), t;
    }
  }]);

  return Ne;
}( /*#__PURE__*/_wrapNativeSuper(Error), Symbol.toStringTag);

function xe(e) {
  return e === void 0 || e.length === 0 ? void 0 : e;
}

function O(e, t, n) {
  return new Ne("Syntax Error: ".concat(n), {
    source: e,
    positions: [t]
  });
}

var an = /*#__PURE__*/function (_Symbol$toStringTag2) {
  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The Token at which this Node begins.
   */

  /**
   * The Token at which this Node ends.
   */

  /**
   * The Source document the AST represents.
   */
  function an(t, n, s) {
    _classCallCheck(this, an);

    this.start = t.start, this.end = n.end, this.startToken = t, this.endToken = n, this.source = s;
  }

  _createClass(an, [{
    key: _Symbol$toStringTag2,
    get: function get() {
      return "Location";
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        start: this.start,
        end: this.end
      };
    }
  }]);

  return an;
}(Symbol.toStringTag);

var rt = /*#__PURE__*/function (_Symbol$toStringTag3) {
  /**
   * The kind of Token.
   */

  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The 1-indexed line number on which this Token appears.
   */

  /**
   * The 1-indexed column number at which this Token begins.
   */

  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */

  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  function rt(t, n, s, i, r, a) {
    _classCallCheck(this, rt);

    this.kind = t, this.start = n, this.end = s, this.line = i, this.column = r, this.value = a, this.prev = null, this.next = null;
  }

  _createClass(rt, [{
    key: _Symbol$toStringTag3,
    get: function get() {
      return "Token";
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        kind: this.kind,
        value: this.value,
        line: this.line,
        column: this.column
      };
    }
  }]);

  return rt;
}(Symbol.toStringTag);

var on = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: ["name", "variableDefinitions", "directives", "selectionSet"],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: ["name", // Note: fragment variable definitions are deprecated and will removed in v17.0.0
  "variableDefinitions", "typeCondition", "directives", "selectionSet"],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: ["description", "name", "type", "defaultValue", "directives"],
  InterfaceTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
};
new Set(Object.keys(on));
var x;

(function (e) {
  e.QUERY = "query", e.MUTATION = "mutation", e.SUBSCRIPTION = "subscription";
})(x || (x = {}));

var oe;

(function (e) {
  e.QUERY = "QUERY", e.MUTATION = "MUTATION", e.SUBSCRIPTION = "SUBSCRIPTION", e.FIELD = "FIELD", e.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", e.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", e.INLINE_FRAGMENT = "INLINE_FRAGMENT", e.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", e.SCHEMA = "SCHEMA", e.SCALAR = "SCALAR", e.OBJECT = "OBJECT", e.FIELD_DEFINITION = "FIELD_DEFINITION", e.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", e.INTERFACE = "INTERFACE", e.UNION = "UNION", e.ENUM = "ENUM", e.ENUM_VALUE = "ENUM_VALUE", e.INPUT_OBJECT = "INPUT_OBJECT", e.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(oe || (oe = {}));

var f;

(function (e) {
  e.NAME = "Name", e.DOCUMENT = "Document", e.OPERATION_DEFINITION = "OperationDefinition", e.VARIABLE_DEFINITION = "VariableDefinition", e.SELECTION_SET = "SelectionSet", e.FIELD = "Field", e.ARGUMENT = "Argument", e.FRAGMENT_SPREAD = "FragmentSpread", e.INLINE_FRAGMENT = "InlineFragment", e.FRAGMENT_DEFINITION = "FragmentDefinition", e.VARIABLE = "Variable", e.INT = "IntValue", e.FLOAT = "FloatValue", e.STRING = "StringValue", e.BOOLEAN = "BooleanValue", e.NULL = "NullValue", e.ENUM = "EnumValue", e.LIST = "ListValue", e.OBJECT = "ObjectValue", e.OBJECT_FIELD = "ObjectField", e.DIRECTIVE = "Directive", e.NAMED_TYPE = "NamedType", e.LIST_TYPE = "ListType", e.NON_NULL_TYPE = "NonNullType", e.SCHEMA_DEFINITION = "SchemaDefinition", e.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", e.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", e.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", e.FIELD_DEFINITION = "FieldDefinition", e.INPUT_VALUE_DEFINITION = "InputValueDefinition", e.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", e.UNION_TYPE_DEFINITION = "UnionTypeDefinition", e.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", e.ENUM_VALUE_DEFINITION = "EnumValueDefinition", e.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", e.DIRECTIVE_DEFINITION = "DirectiveDefinition", e.SCHEMA_EXTENSION = "SchemaExtension", e.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", e.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", e.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", e.UNION_TYPE_EXTENSION = "UnionTypeExtension", e.ENUM_TYPE_EXTENSION = "EnumTypeExtension", e.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension";
})(f || (f = {}));

function cn(e) {
  return e === 9 || e === 32;
}

function G(e) {
  return e >= 48 && e <= 57;
}

function at(e) {
  return e >= 97 && e <= 122 || // A-Z
  e >= 65 && e <= 90;
}

function ot(e) {
  return at(e) || e === 95;
}

function ln(e) {
  return at(e) || G(e) || e === 95;
}

function un(e) {
  var t;
  var n = Number.MAX_SAFE_INTEGER,
      s = null,
      i = -1;

  for (var a = 0; a < e.length; ++a) {
    var r;
    var o = e[a],
        l = dn(o);
    l !== o.length && (s = (r = s) !== null && r !== void 0 ? r : a, i = a, a !== 0 && l < n && (n = l));
  }

  return e.map(function (a, o) {
    return o === 0 ? a : a.slice(n);
  }).slice((t = s) !== null && t !== void 0 ? t : 0, i + 1);
}

function dn(e) {
  var t = 0;

  for (; t < e.length && cn(e.charCodeAt(t));) {
    ++t;
  }

  return t;
}

var c;

(function (e) {
  e.SOF = "<SOF>", e.EOF = "<EOF>", e.BANG = "!", e.DOLLAR = "$", e.AMP = "&", e.PAREN_L = "(", e.PAREN_R = ")", e.SPREAD = "...", e.COLON = ":", e.EQUALS = "=", e.AT = "@", e.BRACKET_L = "[", e.BRACKET_R = "]", e.BRACE_L = "{", e.PIPE = "|", e.BRACE_R = "}", e.NAME = "Name", e.INT = "Int", e.FLOAT = "Float", e.STRING = "String", e.BLOCK_STRING = "BlockString", e.COMMENT = "Comment";
})(c || (c = {}));

var hn = /*#__PURE__*/function (_Symbol$toStringTag4) {
  /**
   * The previously focused non-ignored token.
   */

  /**
   * The currently focused non-ignored token.
   */

  /**
   * The (1-indexed) line containing the current token.
   */

  /**
   * The character offset at which the current line begins.
   */
  function hn(t) {
    _classCallCheck(this, hn);

    var n = new rt(c.SOF, 0, 0, 0, 0);
    this.source = t, this.lastToken = n, this.token = n, this.line = 1, this.lineStart = 0;
  }

  _createClass(hn, [{
    key: _Symbol$toStringTag4,
    get: function get() {
      return "Lexer";
    }
    /**
     * Advances the token stream to the next non-ignored token.
     */

  }, {
    key: "advance",
    value: function advance() {
      return this.lastToken = this.token, this.token = this.lookahead();
    }
    /**
     * Looks ahead and returns the next non-ignored token, but does not change
     * the state of Lexer.
     */

  }, {
    key: "lookahead",
    value: function lookahead() {
      var t = this.token;
      if (t.kind !== c.EOF) do {
        if (t.next) t = t.next;else {
          var n = En(this, t.end);
          t.next = n, n.prev = t, t = n;
        }
      } while (t.kind === c.COMMENT);
      return t;
    }
  }]);

  return hn;
}(Symbol.toStringTag);

function fn(e) {
  return e === c.BANG || e === c.DOLLAR || e === c.AMP || e === c.PAREN_L || e === c.PAREN_R || e === c.SPREAD || e === c.COLON || e === c.EQUALS || e === c.AT || e === c.BRACKET_L || e === c.BRACKET_R || e === c.BRACE_L || e === c.PIPE || e === c.BRACE_R;
}

function B(e) {
  return e >= 0 && e <= 55295 || e >= 57344 && e <= 1114111;
}

function J(e, t) {
  return ct(e.charCodeAt(t)) && lt(e.charCodeAt(t + 1));
}

function ct(e) {
  return e >= 55296 && e <= 56319;
}

function lt(e) {
  return e >= 56320 && e <= 57343;
}

function v(e, t) {
  var n = e.source.body.codePointAt(t);
  if (n === void 0) return c.EOF;

  if (n >= 32 && n <= 126) {
    var s = String.fromCodePoint(n);
    return s === '"' ? "'\"'" : "\"".concat(s, "\"");
  }

  return "U+" + n.toString(16).toUpperCase().padStart(4, "0");
}

function I(e, t, n, s, i) {
  var r = e.line,
      a = 1 + n - e.lineStart;
  return new rt(t, n, s, r, a, i);
}

function En(e, t) {
  var n = e.source.body,
      s = n.length;
  var i = t;

  for (; i < s;) {
    var r = n.charCodeAt(i);

    switch (r) {
      case 65279:
      case 9:
      case 32:
      case 44:
        ++i;
        continue;

      case 10:
        ++i, ++e.line, e.lineStart = i;
        continue;

      case 13:
        n.charCodeAt(i + 1) === 10 ? i += 2 : ++i, ++e.line, e.lineStart = i;
        continue;

      case 35:
        return pn(e, i);

      case 33:
        return I(e, c.BANG, i, i + 1);

      case 36:
        return I(e, c.DOLLAR, i, i + 1);

      case 38:
        return I(e, c.AMP, i, i + 1);

      case 40:
        return I(e, c.PAREN_L, i, i + 1);

      case 41:
        return I(e, c.PAREN_R, i, i + 1);

      case 46:
        if (n.charCodeAt(i + 1) === 46 && n.charCodeAt(i + 2) === 46) return I(e, c.SPREAD, i, i + 3);
        break;

      case 58:
        return I(e, c.COLON, i, i + 1);

      case 61:
        return I(e, c.EQUALS, i, i + 1);

      case 64:
        return I(e, c.AT, i, i + 1);

      case 91:
        return I(e, c.BRACKET_L, i, i + 1);

      case 93:
        return I(e, c.BRACKET_R, i, i + 1);

      case 123:
        return I(e, c.BRACE_L, i, i + 1);

      case 124:
        return I(e, c.PIPE, i, i + 1);

      case 125:
        return I(e, c.BRACE_R, i, i + 1);

      case 34:
        return n.charCodeAt(i + 1) === 34 && n.charCodeAt(i + 2) === 34 ? mn(e, i) : Nn(e, i);
    }

    if (G(r) || r === 45) return Tn(e, i, r);
    if (ot(r)) return On(e, i);
    throw O(e.source, i, r === 39 ? "Unexpected single quote character ('), did you mean to use a double quote (\")?" : B(r) || J(n, i) ? "Unexpected character: ".concat(v(e, i), ".") : "Invalid character: ".concat(v(e, i), "."));
  }

  return I(e, c.EOF, s, s);
}

function pn(e, t) {
  var n = e.source.body,
      s = n.length;
  var i = t + 1;

  for (; i < s;) {
    var r = n.charCodeAt(i);
    if (r === 10 || r === 13) break;
    if (B(r)) ++i;else if (J(n, i)) i += 2;else break;
  }

  return I(e, c.COMMENT, t, i, n.slice(t + 1, i));
}

function Tn(e, t, n) {
  var s = e.source.body;
  var i = t,
      r = n,
      a = !1;

  if (r === 45 && (r = s.charCodeAt(++i)), r === 48) {
    if (r = s.charCodeAt(++i), G(r)) throw O(e.source, i, "Invalid number, unexpected digit after 0: ".concat(v(e, i), "."));
  } else i = te(e, i, r), r = s.charCodeAt(i);

  if (r === 46 && (a = !0, r = s.charCodeAt(++i), i = te(e, i, r), r = s.charCodeAt(i)), (r === 69 || r === 101) && (a = !0, r = s.charCodeAt(++i), (r === 43 || r === 45) && (r = s.charCodeAt(++i)), i = te(e, i, r), r = s.charCodeAt(i)), r === 46 || ot(r)) throw O(e.source, i, "Invalid number, expected digit but got: ".concat(v(e, i), "."));
  return I(e, a ? c.FLOAT : c.INT, t, i, s.slice(t, i));
}

function te(e, t, n) {
  if (!G(n)) throw O(e.source, t, "Invalid number, expected digit but got: ".concat(v(e, t), "."));
  var s = e.source.body;
  var i = t + 1;

  for (; G(s.charCodeAt(i));) {
    ++i;
  }

  return i;
}

function Nn(e, t) {
  var n = e.source.body,
      s = n.length;
  var i = t + 1,
      r = i,
      a = "";

  for (; i < s;) {
    var o = n.charCodeAt(i);
    if (o === 34) return a += n.slice(r, i), I(e, c.STRING, t, i + 1, a);

    if (o === 92) {
      a += n.slice(r, i);
      var l = n.charCodeAt(i + 1) === 117 ? n.charCodeAt(i + 2) === 123 ? yn(e, i) : _n(e, i) : In(e, i);
      a += l.value, i += l.size, r = i;
      continue;
    }

    if (o === 10 || o === 13) break;
    if (B(o)) ++i;else if (J(n, i)) i += 2;else throw O(e.source, i, "Invalid character within String: ".concat(v(e, i), "."));
  }

  throw O(e.source, i, "Unterminated string.");
}

function yn(e, t) {
  var n = e.source.body;
  var s = 0,
      i = 3;

  for (; i < 12;) {
    var r = n.charCodeAt(t + i++);

    if (r === 125) {
      if (i < 5 || !B(s)) break;
      return {
        value: String.fromCodePoint(s),
        size: i
      };
    }

    if (s = s << 4 | F(r), s < 0) break;
  }

  throw O(e.source, t, "Invalid Unicode escape sequence: \"".concat(n.slice(t, t + i), "\"."));
}

function _n(e, t) {
  var n = e.source.body,
      s = ke(n, t + 2);
  if (B(s)) return {
    value: String.fromCodePoint(s),
    size: 6
  };

  if (ct(s) && n.charCodeAt(t + 6) === 92 && n.charCodeAt(t + 7) === 117) {
    var i = ke(n, t + 8);
    if (lt(i)) return {
      value: String.fromCodePoint(s, i),
      size: 12
    };
  }

  throw O(e.source, t, "Invalid Unicode escape sequence: \"".concat(n.slice(t, t + 6), "\"."));
}

function ke(e, t) {
  return F(e.charCodeAt(t)) << 12 | F(e.charCodeAt(t + 1)) << 8 | F(e.charCodeAt(t + 2)) << 4 | F(e.charCodeAt(t + 3));
}

function F(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
}

function In(e, t) {
  var n = e.source.body;

  switch (n.charCodeAt(t + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };

    case 92:
      return {
        value: "\\",
        size: 2
      };

    case 47:
      return {
        value: "/",
        size: 2
      };

    case 98:
      return {
        value: "\b",
        size: 2
      };

    case 102:
      return {
        value: "\f",
        size: 2
      };

    case 110:
      return {
        value: "\n",
        size: 2
      };

    case 114:
      return {
        value: "\r",
        size: 2
      };

    case 116:
      return {
        value: "	",
        size: 2
      };
  }

  throw O(e.source, t, "Invalid character escape sequence: \"".concat(n.slice(t, t + 2), "\"."));
}

function mn(e, t) {
  var n = e.source.body,
      s = n.length;
  var i = e.lineStart,
      r = t + 3,
      a = r,
      o = "";
  var l = [];

  for (; r < s;) {
    var u = n.charCodeAt(r);

    if (u === 34 && n.charCodeAt(r + 1) === 34 && n.charCodeAt(r + 2) === 34) {
      o += n.slice(a, r), l.push(o);
      var d = I(e, c.BLOCK_STRING, t, r + 3, // Return a string of the lines joined with U+000A.
      un(l).join("\n"));
      return e.line += l.length - 1, e.lineStart = i, d;
    }

    if (u === 92 && n.charCodeAt(r + 1) === 34 && n.charCodeAt(r + 2) === 34 && n.charCodeAt(r + 3) === 34) {
      o += n.slice(a, r), a = r + 1, r += 4;
      continue;
    }

    if (u === 10 || u === 13) {
      o += n.slice(a, r), l.push(o), u === 13 && n.charCodeAt(r + 1) === 10 ? r += 2 : ++r, o = "", a = r, i = r;
      continue;
    }

    if (B(u)) ++r;else if (J(n, r)) r += 2;else throw O(e.source, r, "Invalid character within String: ".concat(v(e, r), "."));
  }

  throw O(e.source, r, "Unterminated string.");
}

function On(e, t) {
  var n = e.source.body,
      s = n.length;
  var i = t + 1;

  for (; i < s;) {
    var r = n.charCodeAt(i);
    if (ln(r)) ++i;else break;
  }

  return I(e, c.NAME, t, i, n.slice(t, i));
}

var Sn = 10,
    ut = 2;

function dt(e) {
  return q(e, []);
}

function q(e, t) {
  switch (typeof e) {
    case "string":
      return JSON.stringify(e);

    case "function":
      return e.name ? "[function ".concat(e.name, "]") : "[function]";

    case "object":
      return Dn(e, t);

    default:
      return String(e);
  }
}

function Dn(e, t) {
  if (e === null) return "null";
  if (t.includes(e)) return "[Circular]";
  var n = [].concat(_toConsumableArray(t), [e]);

  if (gn(e)) {
    var s = e.toJSON();
    if (s !== e) return typeof s == "string" ? s : q(s, n);
  } else if (Array.isArray(e)) return Ln(e, n);

  return An(e, n);
}

function gn(e) {
  return typeof e.toJSON == "function";
}

function An(e, t) {
  var n = Object.entries(e);
  return n.length === 0 ? "{}" : t.length > ut ? "[" + Cn(e) + "]" : "{ " + n.map(function (_ref19) {
    var _ref20 = _slicedToArray(_ref19, 2),
        i = _ref20[0],
        r = _ref20[1];

    return i + ": " + q(r, t);
  }).join(", ") + " }";
}

function Ln(e, t) {
  if (e.length === 0) return "[]";
  if (t.length > ut) return "[Array]";
  var n = Math.min(Sn, e.length),
      s = e.length - n,
      i = [];

  for (var r = 0; r < n; ++r) {
    i.push(q(e[r], t));
  }

  return s === 1 ? i.push("... 1 more item") : s > 1 && i.push("... ".concat(s, " more items")), "[" + i.join(", ") + "]";
}

function Cn(e) {
  var t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");

  if (t === "Object" && typeof e.constructor == "function") {
    var n = e.constructor.name;
    if (typeof n == "string" && n !== "") return n;
  }

  return t;
}

var bn =
/* c8 ignore next 6 */
// FIXME: https://github.com/graphql/graphql-js/issues/2317
globalThis.process && globalThis.process.env.NODE_ENV === "production" ? function (t, n) {
  return t instanceof n;
} : function (t, n) {
  if (t instanceof n) return !0;

  if (typeof t == "object" && t !== null) {
    var s;
    var i = n.prototype[Symbol.toStringTag],
        r = // We still need to support constructor's name to detect conflicts with older versions of this library.
    Symbol.toStringTag in t ? t[Symbol.toStringTag] : (s = t.constructor) === null || s === void 0 ? void 0 : s.name;

    if (i === r) {
      var a = dt(t);
      throw new Error("Cannot use ".concat(i, " \"").concat(a, "\" from another module or realm.\n\nEnsure that there is only one instance of \"graphql\" in the node_modules\ndirectory. If different versions of \"graphql\" are the dependencies of other\nrelied on modules, use \"resolutions\" to ensure only one version is installed.\n\nhttps://yarnpkg.com/en/docs/selective-version-resolutions\n\nDuplicate \"graphql\" modules cannot be used at the same time since different\nversions may have different capabilities and behavior. The data from one\nversion used in the function from another could produce confusing and\nspurious results."));
    }
  }

  return !1;
};

var ht = /*#__PURE__*/function (_Symbol$toStringTag5) {
  function ht(t) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "GraphQL request";
    var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      line: 1,
      column: 1
    };

    _classCallCheck(this, ht);

    typeof t == "string" || ee(!1, "Body must be a string. Received: ".concat(dt(t), ".")), this.body = t, this.name = n, this.locationOffset = s, this.locationOffset.line > 0 || ee(!1, "line in locationOffset is 1-indexed and must be positive."), this.locationOffset.column > 0 || ee(!1, "column in locationOffset is 1-indexed and must be positive.");
  }

  _createClass(ht, [{
    key: _Symbol$toStringTag5,
    get: function get() {
      return "Source";
    }
  }]);

  return ht;
}(Symbol.toStringTag);

function vn(e) {
  return bn(e, ht);
}

function Rn(e, t) {
  return new xn(e, t).parseDocument();
}

var xn = /*#__PURE__*/function () {
  function xn(t) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, xn);

    var s = vn(t) ? t : new ht(t);
    this._lexer = new hn(s), this._options = n, this._tokenCounter = 0;
  }
  /**
   * Converts a name lex token into a name parse node.
   */


  _createClass(xn, [{
    key: "parseName",
    value: function parseName() {
      var t = this.expectToken(c.NAME);
      return this.node(t, {
        kind: f.NAME,
        value: t.value
      });
    } // Implements the parsing rules in the Document section.

    /**
     * Document : Definition+
     */

  }, {
    key: "parseDocument",
    value: function parseDocument() {
      return this.node(this._lexer.token, {
        kind: f.DOCUMENT,
        definitions: this.many(c.SOF, this.parseDefinition, c.EOF)
      });
    }
    /**
     * Definition :
     *   - ExecutableDefinition
     *   - TypeSystemDefinition
     *   - TypeSystemExtension
     *
     * ExecutableDefinition :
     *   - OperationDefinition
     *   - FragmentDefinition
     *
     * TypeSystemDefinition :
     *   - SchemaDefinition
     *   - TypeDefinition
     *   - DirectiveDefinition
     *
     * TypeDefinition :
     *   - ScalarTypeDefinition
     *   - ObjectTypeDefinition
     *   - InterfaceTypeDefinition
     *   - UnionTypeDefinition
     *   - EnumTypeDefinition
     *   - InputObjectTypeDefinition
     */

  }, {
    key: "parseDefinition",
    value: function parseDefinition() {
      if (this.peek(c.BRACE_L)) return this.parseOperationDefinition();
      var t = this.peekDescription(),
          n = t ? this._lexer.lookahead() : this._lexer.token;

      if (n.kind === c.NAME) {
        switch (n.value) {
          case "schema":
            return this.parseSchemaDefinition();

          case "scalar":
            return this.parseScalarTypeDefinition();

          case "type":
            return this.parseObjectTypeDefinition();

          case "interface":
            return this.parseInterfaceTypeDefinition();

          case "union":
            return this.parseUnionTypeDefinition();

          case "enum":
            return this.parseEnumTypeDefinition();

          case "input":
            return this.parseInputObjectTypeDefinition();

          case "directive":
            return this.parseDirectiveDefinition();
        }

        if (t) throw O(this._lexer.source, this._lexer.token.start, "Unexpected description, descriptions are supported only on type definitions.");

        switch (n.value) {
          case "query":
          case "mutation":
          case "subscription":
            return this.parseOperationDefinition();

          case "fragment":
            return this.parseFragmentDefinition();

          case "extend":
            return this.parseTypeSystemExtension();
        }
      }

      throw this.unexpected(n);
    } // Implements the parsing rules in the Operations section.

    /**
     * OperationDefinition :
     *  - SelectionSet
     *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
     */

  }, {
    key: "parseOperationDefinition",
    value: function parseOperationDefinition() {
      var t = this._lexer.token;
      if (this.peek(c.BRACE_L)) return this.node(t, {
        kind: f.OPERATION_DEFINITION,
        operation: x.QUERY,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
      var n = this.parseOperationType();
      var s;
      return this.peek(c.NAME) && (s = this.parseName()), this.node(t, {
        kind: f.OPERATION_DEFINITION,
        operation: n,
        name: s,
        variableDefinitions: this.parseVariableDefinitions(),
        directives: this.parseDirectives(!1),
        selectionSet: this.parseSelectionSet()
      });
    }
    /**
     * OperationType : one of query mutation subscription
     */

  }, {
    key: "parseOperationType",
    value: function parseOperationType() {
      var t = this.expectToken(c.NAME);

      switch (t.value) {
        case "query":
          return x.QUERY;

        case "mutation":
          return x.MUTATION;

        case "subscription":
          return x.SUBSCRIPTION;
      }

      throw this.unexpected(t);
    }
    /**
     * VariableDefinitions : ( VariableDefinition+ )
     */

  }, {
    key: "parseVariableDefinitions",
    value: function parseVariableDefinitions() {
      return this.optionalMany(c.PAREN_L, this.parseVariableDefinition, c.PAREN_R);
    }
    /**
     * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
     */

  }, {
    key: "parseVariableDefinition",
    value: function parseVariableDefinition() {
      return this.node(this._lexer.token, {
        kind: f.VARIABLE_DEFINITION,
        variable: this.parseVariable(),
        type: (this.expectToken(c.COLON), this.parseTypeReference()),
        defaultValue: this.expectOptionalToken(c.EQUALS) ? this.parseConstValueLiteral() : void 0,
        directives: this.parseConstDirectives()
      });
    }
    /**
     * Variable : $ Name
     */

  }, {
    key: "parseVariable",
    value: function parseVariable() {
      var t = this._lexer.token;
      return this.expectToken(c.DOLLAR), this.node(t, {
        kind: f.VARIABLE,
        name: this.parseName()
      });
    }
    /**
     * ```
     * SelectionSet : { Selection+ }
     * ```
     */

  }, {
    key: "parseSelectionSet",
    value: function parseSelectionSet() {
      return this.node(this._lexer.token, {
        kind: f.SELECTION_SET,
        selections: this.many(c.BRACE_L, this.parseSelection, c.BRACE_R)
      });
    }
    /**
     * Selection :
     *   - Field
     *   - FragmentSpread
     *   - InlineFragment
     */

  }, {
    key: "parseSelection",
    value: function parseSelection() {
      return this.peek(c.SPREAD) ? this.parseFragment() : this.parseField();
    }
    /**
     * Field : Alias? Name Arguments? Directives? SelectionSet?
     *
     * Alias : Name :
     */

  }, {
    key: "parseField",
    value: function parseField() {
      var t = this._lexer.token,
          n = this.parseName();
      var s, i;
      return this.expectOptionalToken(c.COLON) ? (s = n, i = this.parseName()) : i = n, this.node(t, {
        kind: f.FIELD,
        alias: s,
        name: i,
        arguments: this.parseArguments(!1),
        directives: this.parseDirectives(!1),
        selectionSet: this.peek(c.BRACE_L) ? this.parseSelectionSet() : void 0
      });
    }
    /**
     * Arguments[Const] : ( Argument[?Const]+ )
     */

  }, {
    key: "parseArguments",
    value: function parseArguments(t) {
      var n = t ? this.parseConstArgument : this.parseArgument;
      return this.optionalMany(c.PAREN_L, n, c.PAREN_R);
    }
    /**
     * Argument[Const] : Name : Value[?Const]
     */

  }, {
    key: "parseArgument",
    value: function parseArgument() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var n = this._lexer.token,
          s = this.parseName();
      return this.expectToken(c.COLON), this.node(n, {
        kind: f.ARGUMENT,
        name: s,
        value: this.parseValueLiteral(t)
      });
    }
  }, {
    key: "parseConstArgument",
    value: function parseConstArgument() {
      return this.parseArgument(!0);
    } // Implements the parsing rules in the Fragments section.

    /**
     * Corresponds to both FragmentSpread and InlineFragment in the spec.
     *
     * FragmentSpread : ... FragmentName Directives?
     *
     * InlineFragment : ... TypeCondition? Directives? SelectionSet
     */

  }, {
    key: "parseFragment",
    value: function parseFragment() {
      var t = this._lexer.token;
      this.expectToken(c.SPREAD);
      var n = this.expectOptionalKeyword("on");
      return !n && this.peek(c.NAME) ? this.node(t, {
        kind: f.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(!1)
      }) : this.node(t, {
        kind: f.INLINE_FRAGMENT,
        typeCondition: n ? this.parseNamedType() : void 0,
        directives: this.parseDirectives(!1),
        selectionSet: this.parseSelectionSet()
      });
    }
    /**
     * FragmentDefinition :
     *   - fragment FragmentName on TypeCondition Directives? SelectionSet
     *
     * TypeCondition : NamedType
     */

  }, {
    key: "parseFragmentDefinition",
    value: function parseFragmentDefinition() {
      var t = this._lexer.token;
      return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(t, {
        kind: f.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
        directives: this.parseDirectives(!1),
        selectionSet: this.parseSelectionSet()
      }) : this.node(t, {
        kind: f.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
        directives: this.parseDirectives(!1),
        selectionSet: this.parseSelectionSet()
      });
    }
    /**
     * FragmentName : Name but not `on`
     */

  }, {
    key: "parseFragmentName",
    value: function parseFragmentName() {
      if (this._lexer.token.value === "on") throw this.unexpected();
      return this.parseName();
    } // Implements the parsing rules in the Values section.

    /**
     * Value[Const] :
     *   - [~Const] Variable
     *   - IntValue
     *   - FloatValue
     *   - StringValue
     *   - BooleanValue
     *   - NullValue
     *   - EnumValue
     *   - ListValue[?Const]
     *   - ObjectValue[?Const]
     *
     * BooleanValue : one of `true` `false`
     *
     * NullValue : `null`
     *
     * EnumValue : Name but not `true`, `false` or `null`
     */

  }, {
    key: "parseValueLiteral",
    value: function parseValueLiteral(t) {
      var n = this._lexer.token;

      switch (n.kind) {
        case c.BRACKET_L:
          return this.parseList(t);

        case c.BRACE_L:
          return this.parseObject(t);

        case c.INT:
          return this.advanceLexer(), this.node(n, {
            kind: f.INT,
            value: n.value
          });

        case c.FLOAT:
          return this.advanceLexer(), this.node(n, {
            kind: f.FLOAT,
            value: n.value
          });

        case c.STRING:
        case c.BLOCK_STRING:
          return this.parseStringLiteral();

        case c.NAME:
          switch (this.advanceLexer(), n.value) {
            case "true":
              return this.node(n, {
                kind: f.BOOLEAN,
                value: !0
              });

            case "false":
              return this.node(n, {
                kind: f.BOOLEAN,
                value: !1
              });

            case "null":
              return this.node(n, {
                kind: f.NULL
              });

            default:
              return this.node(n, {
                kind: f.ENUM,
                value: n.value
              });
          }

        case c.DOLLAR:
          if (t) if (this.expectToken(c.DOLLAR), this._lexer.token.kind === c.NAME) {
            var s = this._lexer.token.value;
            throw O(this._lexer.source, n.start, "Unexpected variable \"$".concat(s, "\" in constant value."));
          } else throw this.unexpected(n);
          return this.parseVariable();

        default:
          throw this.unexpected();
      }
    }
  }, {
    key: "parseConstValueLiteral",
    value: function parseConstValueLiteral() {
      return this.parseValueLiteral(!0);
    }
  }, {
    key: "parseStringLiteral",
    value: function parseStringLiteral() {
      var t = this._lexer.token;
      return this.advanceLexer(), this.node(t, {
        kind: f.STRING,
        value: t.value,
        block: t.kind === c.BLOCK_STRING
      });
    }
    /**
     * ListValue[Const] :
     *   - [ ]
     *   - [ Value[?Const]+ ]
     */

  }, {
    key: "parseList",
    value: function parseList(t) {
      var _this7 = this;

      var n = function n() {
        return _this7.parseValueLiteral(t);
      };

      return this.node(this._lexer.token, {
        kind: f.LIST,
        values: this.any(c.BRACKET_L, n, c.BRACKET_R)
      });
    }
    /**
     * ```
     * ObjectValue[Const] :
     *   - { }
     *   - { ObjectField[?Const]+ }
     * ```
     */

  }, {
    key: "parseObject",
    value: function parseObject(t) {
      var _this8 = this;

      var n = function n() {
        return _this8.parseObjectField(t);
      };

      return this.node(this._lexer.token, {
        kind: f.OBJECT,
        fields: this.any(c.BRACE_L, n, c.BRACE_R)
      });
    }
    /**
     * ObjectField[Const] : Name : Value[?Const]
     */

  }, {
    key: "parseObjectField",
    value: function parseObjectField(t) {
      var n = this._lexer.token,
          s = this.parseName();
      return this.expectToken(c.COLON), this.node(n, {
        kind: f.OBJECT_FIELD,
        name: s,
        value: this.parseValueLiteral(t)
      });
    } // Implements the parsing rules in the Directives section.

    /**
     * Directives[Const] : Directive[?Const]+
     */

  }, {
    key: "parseDirectives",
    value: function parseDirectives(t) {
      var n = [];

      for (; this.peek(c.AT);) {
        n.push(this.parseDirective(t));
      }

      return n;
    }
  }, {
    key: "parseConstDirectives",
    value: function parseConstDirectives() {
      return this.parseDirectives(!0);
    }
    /**
     * ```
     * Directive[Const] : @ Name Arguments[?Const]?
     * ```
     */

  }, {
    key: "parseDirective",
    value: function parseDirective(t) {
      var n = this._lexer.token;
      return this.expectToken(c.AT), this.node(n, {
        kind: f.DIRECTIVE,
        name: this.parseName(),
        arguments: this.parseArguments(t)
      });
    } // Implements the parsing rules in the Types section.

    /**
     * Type :
     *   - NamedType
     *   - ListType
     *   - NonNullType
     */

  }, {
    key: "parseTypeReference",
    value: function parseTypeReference() {
      var t = this._lexer.token;
      var n;

      if (this.expectOptionalToken(c.BRACKET_L)) {
        var s = this.parseTypeReference();
        this.expectToken(c.BRACKET_R), n = this.node(t, {
          kind: f.LIST_TYPE,
          type: s
        });
      } else n = this.parseNamedType();

      return this.expectOptionalToken(c.BANG) ? this.node(t, {
        kind: f.NON_NULL_TYPE,
        type: n
      }) : n;
    }
    /**
     * NamedType : Name
     */

  }, {
    key: "parseNamedType",
    value: function parseNamedType() {
      return this.node(this._lexer.token, {
        kind: f.NAMED_TYPE,
        name: this.parseName()
      });
    } // Implements the parsing rules in the Type Definition section.

  }, {
    key: "peekDescription",
    value: function peekDescription() {
      return this.peek(c.STRING) || this.peek(c.BLOCK_STRING);
    }
    /**
     * Description : StringValue
     */

  }, {
    key: "parseDescription",
    value: function parseDescription() {
      if (this.peekDescription()) return this.parseStringLiteral();
    }
    /**
     * ```
     * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
     * ```
     */

  }, {
    key: "parseSchemaDefinition",
    value: function parseSchemaDefinition() {
      var t = this._lexer.token,
          n = this.parseDescription();
      this.expectKeyword("schema");
      var s = this.parseConstDirectives(),
          i = this.many(c.BRACE_L, this.parseOperationTypeDefinition, c.BRACE_R);
      return this.node(t, {
        kind: f.SCHEMA_DEFINITION,
        description: n,
        directives: s,
        operationTypes: i
      });
    }
    /**
     * OperationTypeDefinition : OperationType : NamedType
     */

  }, {
    key: "parseOperationTypeDefinition",
    value: function parseOperationTypeDefinition() {
      var t = this._lexer.token,
          n = this.parseOperationType();
      this.expectToken(c.COLON);
      var s = this.parseNamedType();
      return this.node(t, {
        kind: f.OPERATION_TYPE_DEFINITION,
        operation: n,
        type: s
      });
    }
    /**
     * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
     */

  }, {
    key: "parseScalarTypeDefinition",
    value: function parseScalarTypeDefinition() {
      var t = this._lexer.token,
          n = this.parseDescription();
      this.expectKeyword("scalar");
      var s = this.parseName(),
          i = this.parseConstDirectives();
      return this.node(t, {
        kind: f.SCALAR_TYPE_DEFINITION,
        description: n,
        name: s,
        directives: i
      });
    }
    /**
     * ObjectTypeDefinition :
     *   Description?
     *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
     */

  }, {
    key: "parseObjectTypeDefinition",
    value: function parseObjectTypeDefinition() {
      var t = this._lexer.token,
          n = this.parseDescription();
      this.expectKeyword("type");
      var s = this.parseName(),
          i = this.parseImplementsInterfaces(),
          r = this.parseConstDirectives(),
          a = this.parseFieldsDefinition();
      return this.node(t, {
        kind: f.OBJECT_TYPE_DEFINITION,
        description: n,
        name: s,
        interfaces: i,
        directives: r,
        fields: a
      });
    }
    /**
     * ImplementsInterfaces :
     *   - implements `&`? NamedType
     *   - ImplementsInterfaces & NamedType
     */

  }, {
    key: "parseImplementsInterfaces",
    value: function parseImplementsInterfaces() {
      return this.expectOptionalKeyword("implements") ? this.delimitedMany(c.AMP, this.parseNamedType) : [];
    }
    /**
     * ```
     * FieldsDefinition : { FieldDefinition+ }
     * ```
     */

  }, {
    key: "parseFieldsDefinition",
    value: function parseFieldsDefinition() {
      return this.optionalMany(c.BRACE_L, this.parseFieldDefinition, c.BRACE_R);
    }
    /**
     * FieldDefinition :
     *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
     */

  }, {
    key: "parseFieldDefinition",
    value: function parseFieldDefinition() {
      var t = this._lexer.token,
          n = this.parseDescription(),
          s = this.parseName(),
          i = this.parseArgumentDefs();
      this.expectToken(c.COLON);
      var r = this.parseTypeReference(),
          a = this.parseConstDirectives();
      return this.node(t, {
        kind: f.FIELD_DEFINITION,
        description: n,
        name: s,
        arguments: i,
        type: r,
        directives: a
      });
    }
    /**
     * ArgumentsDefinition : ( InputValueDefinition+ )
     */

  }, {
    key: "parseArgumentDefs",
    value: function parseArgumentDefs() {
      return this.optionalMany(c.PAREN_L, this.parseInputValueDef, c.PAREN_R);
    }
    /**
     * InputValueDefinition :
     *   - Description? Name : Type DefaultValue? Directives[Const]?
     */

  }, {
    key: "parseInputValueDef",
    value: function parseInputValueDef() {
      var t = this._lexer.token,
          n = this.parseDescription(),
          s = this.parseName();
      this.expectToken(c.COLON);
      var i = this.parseTypeReference();
      var r;
      this.expectOptionalToken(c.EQUALS) && (r = this.parseConstValueLiteral());
      var a = this.parseConstDirectives();
      return this.node(t, {
        kind: f.INPUT_VALUE_DEFINITION,
        description: n,
        name: s,
        type: i,
        defaultValue: r,
        directives: a
      });
    }
    /**
     * InterfaceTypeDefinition :
     *   - Description? interface Name Directives[Const]? FieldsDefinition?
     */

  }, {
    key: "parseInterfaceTypeDefinition",
    value: function parseInterfaceTypeDefinition() {
      var t = this._lexer.token,
          n = this.parseDescription();
      this.expectKeyword("interface");
      var s = this.parseName(),
          i = this.parseImplementsInterfaces(),
          r = this.parseConstDirectives(),
          a = this.parseFieldsDefinition();
      return this.node(t, {
        kind: f.INTERFACE_TYPE_DEFINITION,
        description: n,
        name: s,
        interfaces: i,
        directives: r,
        fields: a
      });
    }
    /**
     * UnionTypeDefinition :
     *   - Description? union Name Directives[Const]? UnionMemberTypes?
     */

  }, {
    key: "parseUnionTypeDefinition",
    value: function parseUnionTypeDefinition() {
      var t = this._lexer.token,
          n = this.parseDescription();
      this.expectKeyword("union");
      var s = this.parseName(),
          i = this.parseConstDirectives(),
          r = this.parseUnionMemberTypes();
      return this.node(t, {
        kind: f.UNION_TYPE_DEFINITION,
        description: n,
        name: s,
        directives: i,
        types: r
      });
    }
    /**
     * UnionMemberTypes :
     *   - = `|`? NamedType
     *   - UnionMemberTypes | NamedType
     */

  }, {
    key: "parseUnionMemberTypes",
    value: function parseUnionMemberTypes() {
      return this.expectOptionalToken(c.EQUALS) ? this.delimitedMany(c.PIPE, this.parseNamedType) : [];
    }
    /**
     * EnumTypeDefinition :
     *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
     */

  }, {
    key: "parseEnumTypeDefinition",
    value: function parseEnumTypeDefinition() {
      var t = this._lexer.token,
          n = this.parseDescription();
      this.expectKeyword("enum");
      var s = this.parseName(),
          i = this.parseConstDirectives(),
          r = this.parseEnumValuesDefinition();
      return this.node(t, {
        kind: f.ENUM_TYPE_DEFINITION,
        description: n,
        name: s,
        directives: i,
        values: r
      });
    }
    /**
     * ```
     * EnumValuesDefinition : { EnumValueDefinition+ }
     * ```
     */

  }, {
    key: "parseEnumValuesDefinition",
    value: function parseEnumValuesDefinition() {
      return this.optionalMany(c.BRACE_L, this.parseEnumValueDefinition, c.BRACE_R);
    }
    /**
     * EnumValueDefinition : Description? EnumValue Directives[Const]?
     */

  }, {
    key: "parseEnumValueDefinition",
    value: function parseEnumValueDefinition() {
      var t = this._lexer.token,
          n = this.parseDescription(),
          s = this.parseEnumValueName(),
          i = this.parseConstDirectives();
      return this.node(t, {
        kind: f.ENUM_VALUE_DEFINITION,
        description: n,
        name: s,
        directives: i
      });
    }
    /**
     * EnumValue : Name but not `true`, `false` or `null`
     */

  }, {
    key: "parseEnumValueName",
    value: function parseEnumValueName() {
      if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null") throw O(this._lexer.source, this._lexer.token.start, "".concat(j(this._lexer.token), " is reserved and cannot be used for an enum value."));
      return this.parseName();
    }
    /**
     * InputObjectTypeDefinition :
     *   - Description? input Name Directives[Const]? InputFieldsDefinition?
     */

  }, {
    key: "parseInputObjectTypeDefinition",
    value: function parseInputObjectTypeDefinition() {
      var t = this._lexer.token,
          n = this.parseDescription();
      this.expectKeyword("input");
      var s = this.parseName(),
          i = this.parseConstDirectives(),
          r = this.parseInputFieldsDefinition();
      return this.node(t, {
        kind: f.INPUT_OBJECT_TYPE_DEFINITION,
        description: n,
        name: s,
        directives: i,
        fields: r
      });
    }
    /**
     * ```
     * InputFieldsDefinition : { InputValueDefinition+ }
     * ```
     */

  }, {
    key: "parseInputFieldsDefinition",
    value: function parseInputFieldsDefinition() {
      return this.optionalMany(c.BRACE_L, this.parseInputValueDef, c.BRACE_R);
    }
    /**
     * TypeSystemExtension :
     *   - SchemaExtension
     *   - TypeExtension
     *
     * TypeExtension :
     *   - ScalarTypeExtension
     *   - ObjectTypeExtension
     *   - InterfaceTypeExtension
     *   - UnionTypeExtension
     *   - EnumTypeExtension
     *   - InputObjectTypeDefinition
     */

  }, {
    key: "parseTypeSystemExtension",
    value: function parseTypeSystemExtension() {
      var t = this._lexer.lookahead();

      if (t.kind === c.NAME) switch (t.value) {
        case "schema":
          return this.parseSchemaExtension();

        case "scalar":
          return this.parseScalarTypeExtension();

        case "type":
          return this.parseObjectTypeExtension();

        case "interface":
          return this.parseInterfaceTypeExtension();

        case "union":
          return this.parseUnionTypeExtension();

        case "enum":
          return this.parseEnumTypeExtension();

        case "input":
          return this.parseInputObjectTypeExtension();
      }
      throw this.unexpected(t);
    }
    /**
     * ```
     * SchemaExtension :
     *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
     *  - extend schema Directives[Const]
     * ```
     */

  }, {
    key: "parseSchemaExtension",
    value: function parseSchemaExtension() {
      var t = this._lexer.token;
      this.expectKeyword("extend"), this.expectKeyword("schema");
      var n = this.parseConstDirectives(),
          s = this.optionalMany(c.BRACE_L, this.parseOperationTypeDefinition, c.BRACE_R);
      if (n.length === 0 && s.length === 0) throw this.unexpected();
      return this.node(t, {
        kind: f.SCHEMA_EXTENSION,
        directives: n,
        operationTypes: s
      });
    }
    /**
     * ScalarTypeExtension :
     *   - extend scalar Name Directives[Const]
     */

  }, {
    key: "parseScalarTypeExtension",
    value: function parseScalarTypeExtension() {
      var t = this._lexer.token;
      this.expectKeyword("extend"), this.expectKeyword("scalar");
      var n = this.parseName(),
          s = this.parseConstDirectives();
      if (s.length === 0) throw this.unexpected();
      return this.node(t, {
        kind: f.SCALAR_TYPE_EXTENSION,
        name: n,
        directives: s
      });
    }
    /**
     * ObjectTypeExtension :
     *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
     *  - extend type Name ImplementsInterfaces? Directives[Const]
     *  - extend type Name ImplementsInterfaces
     */

  }, {
    key: "parseObjectTypeExtension",
    value: function parseObjectTypeExtension() {
      var t = this._lexer.token;
      this.expectKeyword("extend"), this.expectKeyword("type");
      var n = this.parseName(),
          s = this.parseImplementsInterfaces(),
          i = this.parseConstDirectives(),
          r = this.parseFieldsDefinition();
      if (s.length === 0 && i.length === 0 && r.length === 0) throw this.unexpected();
      return this.node(t, {
        kind: f.OBJECT_TYPE_EXTENSION,
        name: n,
        interfaces: s,
        directives: i,
        fields: r
      });
    }
    /**
     * InterfaceTypeExtension :
     *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
     *  - extend interface Name ImplementsInterfaces? Directives[Const]
     *  - extend interface Name ImplementsInterfaces
     */

  }, {
    key: "parseInterfaceTypeExtension",
    value: function parseInterfaceTypeExtension() {
      var t = this._lexer.token;
      this.expectKeyword("extend"), this.expectKeyword("interface");
      var n = this.parseName(),
          s = this.parseImplementsInterfaces(),
          i = this.parseConstDirectives(),
          r = this.parseFieldsDefinition();
      if (s.length === 0 && i.length === 0 && r.length === 0) throw this.unexpected();
      return this.node(t, {
        kind: f.INTERFACE_TYPE_EXTENSION,
        name: n,
        interfaces: s,
        directives: i,
        fields: r
      });
    }
    /**
     * UnionTypeExtension :
     *   - extend union Name Directives[Const]? UnionMemberTypes
     *   - extend union Name Directives[Const]
     */

  }, {
    key: "parseUnionTypeExtension",
    value: function parseUnionTypeExtension() {
      var t = this._lexer.token;
      this.expectKeyword("extend"), this.expectKeyword("union");
      var n = this.parseName(),
          s = this.parseConstDirectives(),
          i = this.parseUnionMemberTypes();
      if (s.length === 0 && i.length === 0) throw this.unexpected();
      return this.node(t, {
        kind: f.UNION_TYPE_EXTENSION,
        name: n,
        directives: s,
        types: i
      });
    }
    /**
     * EnumTypeExtension :
     *   - extend enum Name Directives[Const]? EnumValuesDefinition
     *   - extend enum Name Directives[Const]
     */

  }, {
    key: "parseEnumTypeExtension",
    value: function parseEnumTypeExtension() {
      var t = this._lexer.token;
      this.expectKeyword("extend"), this.expectKeyword("enum");
      var n = this.parseName(),
          s = this.parseConstDirectives(),
          i = this.parseEnumValuesDefinition();
      if (s.length === 0 && i.length === 0) throw this.unexpected();
      return this.node(t, {
        kind: f.ENUM_TYPE_EXTENSION,
        name: n,
        directives: s,
        values: i
      });
    }
    /**
     * InputObjectTypeExtension :
     *   - extend input Name Directives[Const]? InputFieldsDefinition
     *   - extend input Name Directives[Const]
     */

  }, {
    key: "parseInputObjectTypeExtension",
    value: function parseInputObjectTypeExtension() {
      var t = this._lexer.token;
      this.expectKeyword("extend"), this.expectKeyword("input");
      var n = this.parseName(),
          s = this.parseConstDirectives(),
          i = this.parseInputFieldsDefinition();
      if (s.length === 0 && i.length === 0) throw this.unexpected();
      return this.node(t, {
        kind: f.INPUT_OBJECT_TYPE_EXTENSION,
        name: n,
        directives: s,
        fields: i
      });
    }
    /**
     * ```
     * DirectiveDefinition :
     *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
     * ```
     */

  }, {
    key: "parseDirectiveDefinition",
    value: function parseDirectiveDefinition() {
      var t = this._lexer.token,
          n = this.parseDescription();
      this.expectKeyword("directive"), this.expectToken(c.AT);
      var s = this.parseName(),
          i = this.parseArgumentDefs(),
          r = this.expectOptionalKeyword("repeatable");
      this.expectKeyword("on");
      var a = this.parseDirectiveLocations();
      return this.node(t, {
        kind: f.DIRECTIVE_DEFINITION,
        description: n,
        name: s,
        arguments: i,
        repeatable: r,
        locations: a
      });
    }
    /**
     * DirectiveLocations :
     *   - `|`? DirectiveLocation
     *   - DirectiveLocations | DirectiveLocation
     */

  }, {
    key: "parseDirectiveLocations",
    value: function parseDirectiveLocations() {
      return this.delimitedMany(c.PIPE, this.parseDirectiveLocation);
    }
    /*
     * DirectiveLocation :
     *   - ExecutableDirectiveLocation
     *   - TypeSystemDirectiveLocation
     *
     * ExecutableDirectiveLocation : one of
     *   `QUERY`
     *   `MUTATION`
     *   `SUBSCRIPTION`
     *   `FIELD`
     *   `FRAGMENT_DEFINITION`
     *   `FRAGMENT_SPREAD`
     *   `INLINE_FRAGMENT`
     *
     * TypeSystemDirectiveLocation : one of
     *   `SCHEMA`
     *   `SCALAR`
     *   `OBJECT`
     *   `FIELD_DEFINITION`
     *   `ARGUMENT_DEFINITION`
     *   `INTERFACE`
     *   `UNION`
     *   `ENUM`
     *   `ENUM_VALUE`
     *   `INPUT_OBJECT`
     *   `INPUT_FIELD_DEFINITION`
     */

  }, {
    key: "parseDirectiveLocation",
    value: function parseDirectiveLocation() {
      var t = this._lexer.token,
          n = this.parseName();
      if (Object.prototype.hasOwnProperty.call(oe, n.value)) return n;
      throw this.unexpected(t);
    } // Core parsing utility functions

    /**
     * Returns a node that, if configured to do so, sets a "loc" field as a
     * location object, used to identify the place in the source that created a
     * given parsed object.
     */

  }, {
    key: "node",
    value: function node(t, n) {
      return this._options.noLocation !== !0 && (n.loc = new an(t, this._lexer.lastToken, this._lexer.source)), n;
    }
    /**
     * Determines if the next token is of a given kind
     */

  }, {
    key: "peek",
    value: function peek(t) {
      return this._lexer.token.kind === t;
    }
    /**
     * If the next token is of the given kind, return that token after advancing the lexer.
     * Otherwise, do not change the parser state and throw an error.
     */

  }, {
    key: "expectToken",
    value: function expectToken(t) {
      var n = this._lexer.token;
      if (n.kind === t) return this.advanceLexer(), n;
      throw O(this._lexer.source, n.start, "Expected ".concat(ft(t), ", found ").concat(j(n), "."));
    }
    /**
     * If the next token is of the given kind, return "true" after advancing the lexer.
     * Otherwise, do not change the parser state and return "false".
     */

  }, {
    key: "expectOptionalToken",
    value: function expectOptionalToken(t) {
      return this._lexer.token.kind === t ? (this.advanceLexer(), !0) : !1;
    }
    /**
     * If the next token is a given keyword, advance the lexer.
     * Otherwise, do not change the parser state and throw an error.
     */

  }, {
    key: "expectKeyword",
    value: function expectKeyword(t) {
      var n = this._lexer.token;
      if (n.kind === c.NAME && n.value === t) this.advanceLexer();else throw O(this._lexer.source, n.start, "Expected \"".concat(t, "\", found ").concat(j(n), "."));
    }
    /**
     * If the next token is a given keyword, return "true" after advancing the lexer.
     * Otherwise, do not change the parser state and return "false".
     */

  }, {
    key: "expectOptionalKeyword",
    value: function expectOptionalKeyword(t) {
      var n = this._lexer.token;
      return n.kind === c.NAME && n.value === t ? (this.advanceLexer(), !0) : !1;
    }
    /**
     * Helper function for creating an error when an unexpected lexed token is encountered.
     */

  }, {
    key: "unexpected",
    value: function unexpected(t) {
      var n = t !== null && t !== void 0 ? t : this._lexer.token;
      return O(this._lexer.source, n.start, "Unexpected ".concat(j(n), "."));
    }
    /**
     * Returns a possibly empty list of parse nodes, determined by the parseFn.
     * This list begins with a lex token of openKind and ends with a lex token of closeKind.
     * Advances the parser to the next lex token after the closing token.
     */

  }, {
    key: "any",
    value: function any(t, n, s) {
      this.expectToken(t);
      var i = [];

      for (; !this.expectOptionalToken(s);) {
        i.push(n.call(this));
      }

      return i;
    }
    /**
     * Returns a list of parse nodes, determined by the parseFn.
     * It can be empty only if open token is missing otherwise it will always return non-empty list
     * that begins with a lex token of openKind and ends with a lex token of closeKind.
     * Advances the parser to the next lex token after the closing token.
     */

  }, {
    key: "optionalMany",
    value: function optionalMany(t, n, s) {
      if (this.expectOptionalToken(t)) {
        var i = [];

        do {
          i.push(n.call(this));
        } while (!this.expectOptionalToken(s));

        return i;
      }

      return [];
    }
    /**
     * Returns a non-empty list of parse nodes, determined by the parseFn.
     * This list begins with a lex token of openKind and ends with a lex token of closeKind.
     * Advances the parser to the next lex token after the closing token.
     */

  }, {
    key: "many",
    value: function many(t, n, s) {
      this.expectToken(t);
      var i = [];

      do {
        i.push(n.call(this));
      } while (!this.expectOptionalToken(s));

      return i;
    }
    /**
     * Returns a non-empty list of parse nodes, determined by the parseFn.
     * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
     * Advances the parser to the next lex token after last item in the list.
     */

  }, {
    key: "delimitedMany",
    value: function delimitedMany(t, n) {
      this.expectOptionalToken(t);
      var s = [];

      do {
        s.push(n.call(this));
      } while (this.expectOptionalToken(t));

      return s;
    }
  }, {
    key: "advanceLexer",
    value: function advanceLexer() {
      var t = this._options.maxTokens,
          n = this._lexer.advance();

      if (t !== void 0 && n.kind !== c.EOF && (++this._tokenCounter, this._tokenCounter > t)) throw O(this._lexer.source, n.start, "Document contains more that ".concat(t, " tokens. Parsing aborted."));
    }
  }]);

  return xn;
}();

function j(e) {
  var t = e.value;
  return ft(e.kind) + (t != null ? " \"".concat(t, "\"") : "");
}

function ft(e) {
  return fn(e) ? "\"".concat(e, "\"") : e;
}

var K = /* @__PURE__ */new Map(),
    ce = /* @__PURE__ */new Map(),
    Et = !0,
    Q = !1;

function pt(e) {
  return e.replace(/[\s,]+/g, " ").trim();
}

function kn(e) {
  return pt(e.source.body.substring(e.start, e.end));
}

function wn(e) {
  var t = /* @__PURE__ */new Set(),
      n = [];
  return e.definitions.forEach(function (s) {
    if (s.kind === "FragmentDefinition") {
      var i = s.name.value,
          r = kn(s.loc),
          a = ce.get(i);
      a && !a.has(r) ? Et && console.warn("Warning: fragment with name " + i + " already exists.\ngraphql-tag enforces all fragment names across your application to be unique; read more about\nthis in the docs: http://dev.apollodata.com/core/fragments.html#unique-names") : a || ce.set(i, a = /* @__PURE__ */new Set()), a.add(r), t.has(r) || (t.add(r), n.push(s));
    } else n.push(s);
  }), _$(_$({}, e), {
    definitions: n
  });
}

function Bn(e) {
  var t = new Set(e.definitions);
  t.forEach(function (s) {
    s.loc && delete s.loc, Object.keys(s).forEach(function (i) {
      var r = s[i];
      r && typeof r == "object" && t.add(r);
    });
  });
  var n = e.loc;
  return n && (delete n.startToken, delete n.endToken), e;
}

function Mn(e) {
  var t = pt(e);

  if (!K.has(t)) {
    var n = Rn(e, {
      experimentalFragmentVariables: Q,
      allowLegacyFragmentVariables: Q
    });
    if (!n || n.kind !== "Document") throw new Error("Not a valid GraphQL document.");
    K.set(t, Bn(wn(n)));
  }

  return K.get(t);
}

function k(e) {
  for (var t = [], n = 1; n < arguments.length; n++) {
    t[n - 1] = arguments[n];
  }

  typeof e == "string" && (e = [e]);
  var s = e[0];
  return t.forEach(function (i, r) {
    i && i.kind === "Document" ? s += i.loc.source.body : s += i, s += e[r + 1];
  }), Mn(s);
}

function Un() {
  K.clear(), ce.clear();
}

function Fn() {
  Et = !1;
}

function Pn() {
  Q = !0;
}

function Gn() {
  Q = !1;
}

var U = {
  gql: k,
  resetCaches: Un,
  disableFragmentWarnings: Fn,
  enableExperimentalFragmentVariables: Pn,
  disableExperimentalFragmentVariables: Gn
};

(function (e) {
  e.gql = U.gql, e.resetCaches = U.resetCaches, e.disableFragmentWarnings = U.disableFragmentWarnings, e.enableExperimentalFragmentVariables = U.enableExperimentalFragmentVariables, e.disableExperimentalFragmentVariables = U.disableExperimentalFragmentVariables;
})(k || (k = {}));

k.default = k;
var Vn = k;

function le(e, t) {
  if (t === 0) return _.error("Max depth for validation of subscription data is reached, please provide your data in the correct format."), {
    isGQL: !1,
    sysId: null,
    isREST: !1
  };

  if (Array.isArray(e)) {
    var _iterator10 = _createForOfIteratorHelper(e),
        _step10;

    try {
      for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
        var n = _step10.value;
        var s = le(n, t - 1);
        if (Object.values(s).includes(!0)) return s;
      }
    } catch (err) {
      _iterator10.e(err);
    } finally {
      _iterator10.f();
    }

    return {
      isGQL: !1,
      sysId: null,
      isREST: !1
    };
  } else {
    var _n3 = Object.hasOwn(e, "__typename"),
        _s = Object.hasOwn(e, "sys") ? e.sys.id : null,
        i = Object.hasOwn(e, "fields");

    return _n3 || _s || i ? {
      isGQL: _n3,
      sysId: _s,
      isREST: i
    } : le(Object.values(e), t - 1);
  }
}

function jn(e, t) {
  var n = _objectSpread({}, e);

  if (n.query) {
    if (typeof n.query == "string") try {
      n.query = Vn(n.query);
    } catch (_unused7) {
      _.error("The provided GraphQL query is invalid, please provide it in the correct format.", e), n.query = void 0;
    }
    t && (_.warn("The query param is ignored as it can only be used together with GraphQL.", e), n.query = void 0);
  }

  return n;
}

function Kn(e) {
  var _le = le(e.data, 10),
      t = _le.isGQL,
      n = _le.isREST,
      s = _le.sysId,
      i = jn(e, n);

  return s ? !t && !n ? (_.error('For live updates as a basic requirement the provided data must include the "fields" property for REST or "__typename" for Graphql, otherwise the data will be treated as invalid and live updates are not applied.', i.data), {
    isValid: !1,
    sysId: s,
    isGQL: t,
    isREST: n,
    config: i
  }) : {
    isGQL: t,
    isREST: n,
    sysId: s,
    isValid: !0,
    config: i
  } : (_.error('Live Updates requires the "sys.id" to be present on the provided data', i.data), {
    isValid: !1,
    sysId: s,
    isGQL: t,
    isREST: n,
    config: i
  });
}

var L = /* @__PURE__ */function (e) {
  return e.CONNECTED = "CONNECTED", e.DISCONNECTED = "DISCONNECTED", e.ERROR = "ERROR", e.IFRAME_CONNECTED = "IFRAME_CONNECTED", e.TAGGED_FIELD_CLICKED = "TAGGED_FIELD_CLICKED", e.URL_CHANGED = "URL_CHANGED", e.SUBSCRIBED = "SUBSCRIBED", e.ENTRY_UPDATED = "ENTRY_UPDATED", e.ENTRY_SAVED = "ENTRY_SAVED", e.DEBUG_MODE_ENABLED = "DEBUG_MODE_ENABLED", e.ENTITY_NOT_KNOWN = "ENTITY_NOT_KNOWN", e.UNKNOWN_REFERENCE_LOADED = "UNKNOWN_REFERENCE_LOADED", e;
}(L || {});

function Yn(e, t, n, s) {
  g("TAGGED_FIELD_CLICKED", {
    action: "TAGGED_FIELD_CLICKED",
    fieldId: e,
    entryId: t,
    locale: n
  }, s);
}

function Hn(e, t, n, s) {
  g("TAGGED_FIELD_CLICKED", {
    action: "TAGGED_FIELD_CLICKED",
    fieldId: e,
    assetId: t,
    locale: n
  }, s);
}

function $n(e, t) {
  return e.name === "Asset" ? t.id : t.apiName || t.name;
}

function ye(_x29, _x30, _x31, _x32, _x33, _x34, _x35) {
  return _ye.apply(this, arguments);
}

function _ye() {
  _ye = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(e, t, n, s, i, r, a) {
    var o, l, _yield$fe3, d, u, _d, h;

    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            l = "urn" in t.sys ? t.sys.urn : t.sys.id;

            if (!r.has(l)) {
              _context25.next = 5;
              break;
            }

            _.warn("Detected a circular reference, stopping recursion"), o = r.get(l);
            _context25.next = 10;
            break;

          case 5:
            _context25.next = 7;
            return fe(_objectSpread(_objectSpread({
              entityReferenceMap: s,
              referenceId: t.sys.id
            }, Qe(t) ? {
              isAsset: !0
            } : void 0), {}, {
              locale: n,
              sendMessage: a
            }));

          case 7:
            _yield$fe3 = _context25.sent;
            d = _yield$fe3.reference;
            o = d, r.set(l, d);

          case 10:
            if (o) {
              _context25.next = 12;
              break;
            }

            return _context25.abrupt("return", e);

          case 12:
            u = de(o);
            _context25.t0 = _regeneratorRuntime.keys(o.fields);

          case 14:
            if ((_context25.t1 = _context25.t0()).done) {
              _context25.next = 37;
              break;
            }

            _d = _context25.t1.value;
            h = o.fields[_d];

            if (!(Ce(h) && i < Y)) {
              _context25.next = 22;
              break;
            }

            _context25.next = 20;
            return Nt(u, o, n, _d, s, i + 1, r, a);

          case 20:
            _context25.next = 35;
            break;

          case 22:
            if (!(Array.isArray(h) && Ce(h[0]) && i < Y)) {
              _context25.next = 27;
              break;
            }

            _context25.next = 25;
            return Tt(u, o, n, _d, s, i + 1, r, a);

          case 25:
            _context25.next = 35;
            break;

          case 27:
            if (!pe(h)) {
              _context25.next = 32;
              break;
            }

            _context25.next = 30;
            return _t(u, o, _d, n, s, i + 1, r, a);

          case 30:
            _context25.next = 35;
            break;

          case 32:
            if (!(be(h) || Array.isArray(h) && be(h[0]))) {
              _context25.next = 34;
              break;
            }

            return _context25.abrupt("return", (_.warn("Detected a resource link, support is still under development."), u));

          case 34:
            ue({
              dataFromPreviewApp: u.fields,
              updateFromEntryEditor: o,
              name: _d
            });

          case 35:
            _context25.next = 14;
            break;

          case 37:
            return _context25.abrupt("return", u);

          case 38:
          case "end":
            return _context25.stop();
        }
      }
    }, _callee25);
  }));
  return _ye.apply(this, arguments);
}

function Tt(_x36, _x37, _x38, _x39, _x40, _x41, _x42, _x43) {
  return _Tt.apply(this, arguments);
}

function _Tt() {
  _Tt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(e, t, n, s, i, r, a, o) {
    var l;
    return _regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            if ((l = t.fields) != null && l[s]) {
              _context26.next = 3;
              break;
            }

            delete e.fields[s];
            return _context26.abrupt("return");

          case 3:
            _context26.next = 5;
            return Promise.all(t.fields[s].map(function (u, d) {
              var h;
              return ye((h = e.fields[s]) == null ? void 0 : h[d], u, n, i, r + 1, a, o);
            })).then(function (u) {
              return u.filter(Boolean);
            });

          case 5:
            e.fields[s] = _context26.sent;
            return _context26.abrupt("return", e);

          case 7:
          case "end":
            return _context26.stop();
        }
      }
    }, _callee26);
  }));
  return _Tt.apply(this, arguments);
}

function Nt(_x44, _x45, _x46, _x47, _x48, _x49, _x50, _x51) {
  return _Nt.apply(this, arguments);
}

function _Nt() {
  _Nt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(e, t, n, s, i, r, a, o) {
    var u, l;
    return _regeneratorRuntime.wrap(function _callee27$(_context27) {
      while (1) {
        switch (_context27.prev = _context27.next) {
          case 0:
            l = (u = t == null ? void 0 : t.fields) == null ? void 0 : u[s];

            if (l) {
              _context27.next = 4;
              break;
            }

            delete e.fields[s];
            return _context27.abrupt("return");

          case 4:
            _context27.next = 6;
            return ye(e.fields[s], l, n, i, r + 1, a, o);

          case 6:
            e.fields[s] = _context27.sent;
            return _context27.abrupt("return", e);

          case 8:
          case "end":
            return _context27.stop();
        }
      }
    }, _callee27);
  }));
  return _Nt.apply(this, arguments);
}

function yt(_x52, _x53, _x54, _x55, _x56, _x57) {
  return _yt.apply(this, arguments);
}

function _yt() {
  _yt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(e, t, n, s, i, r) {
    var a, l, _iterator15, _step15, o;

    return _regeneratorRuntime.wrap(function _callee28$(_context28) {
      while (1) {
        switch (_context28.prev = _context28.next) {
          case 0:
            if (!($e.includes(e.nodeType) && e.data && e.data.target && e.data.target.sys && (e.data.target.sys.linkType === "Entry" || e.data.target.sys.linkType === "Asset"))) {
              _context28.next = 5;
              break;
            }

            l = {
              sys: {
                id: ((a = e.data.target) == null ? void 0 : a.sys.id) || "",
                type: "Link",
                linkType: e.data.target.sys.linkType
              }
            };
            _context28.next = 4;
            return ye(void 0, l, n, t, s + 1, i, r);

          case 4:
            e.data.target = _context28.sent;

          case 5:
            if (!e.content) {
              _context28.next = 23;
              break;
            }

            _iterator15 = _createForOfIteratorHelper(e.content);
            _context28.prev = 7;

            _iterator15.s();

          case 9:
            if ((_step15 = _iterator15.n()).done) {
              _context28.next = 15;
              break;
            }

            o = _step15.value;
            _context28.next = 13;
            return yt(o, t, n, s + 1, i, r);

          case 13:
            _context28.next = 9;
            break;

          case 15:
            _context28.next = 20;
            break;

          case 17:
            _context28.prev = 17;
            _context28.t0 = _context28["catch"](7);

            _iterator15.e(_context28.t0);

          case 20:
            _context28.prev = 20;

            _iterator15.f();

            return _context28.finish(20);

          case 23:
          case "end":
            return _context28.stop();
        }
      }
    }, _callee28, null, [[7, 17, 20, 23]]);
  }));
  return _yt.apply(this, arguments);
}

function _t(_x58, _x59, _x60, _x61, _x62, _x63, _x64, _x65) {
  return _t4.apply(this, arguments);
}

function _t4() {
  _t4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(e, t, n, s, i, r, a, o) {
    var u, l, _iterator16, _step16, d;

    return _regeneratorRuntime.wrap(function _callee29$(_context29) {
      while (1) {
        switch (_context29.prev = _context29.next) {
          case 0:
            l = (u = t.fields) == null ? void 0 : u[n];

            if (t.fields[n]) {
              _context29.next = 4;
              break;
            }

            delete e.fields[n];
            return _context29.abrupt("return");

          case 4:
            if (!pe(l)) {
              _context29.next = 23;
              break;
            }

            e.fields[n] = l;
            _iterator16 = _createForOfIteratorHelper(l.content);
            _context29.prev = 7;

            _iterator16.s();

          case 9:
            if ((_step16 = _iterator16.n()).done) {
              _context29.next = 15;
              break;
            }

            d = _step16.value;
            _context29.next = 13;
            return yt(d, i, s, r, a, o);

          case 13:
            _context29.next = 9;
            break;

          case 15:
            _context29.next = 20;
            break;

          case 17:
            _context29.prev = 17;
            _context29.t0 = _context29["catch"](7);

            _iterator16.e(_context29.t0);

          case 20:
            _context29.prev = 20;

            _iterator16.f();

            return _context29.finish(20);

          case 23:
          case "end":
            return _context29.stop();
        }
      }
    }, _callee29, null, [[7, 17, 20, 23]]);
  }));
  return _t4.apply(this, arguments);
}

function Qn(_x66, _x67, _x68, _x69, _x70, _x71, _x72, _x73) {
  return _Qn.apply(this, arguments);
}

function _Qn() {
  _Qn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(e, t, n, s, i, r, a, o) {
    var l, _iterator17, _step17, u, d;

    return _regeneratorRuntime.wrap(function _callee30$(_context30) {
      while (1) {
        switch (_context30.prev = _context30.next) {
          case 0:
            if (!(t.sys.id !== n.sys.id)) {
              _context30.next = 2;
              break;
            }

            return _context30.abrupt("return", t);

          case 2:
            _iterator17 = _createForOfIteratorHelper(e.fields);
            _context30.prev = 3;

            _iterator17.s();

          case 5:
            if ((_step17 = _iterator17.n()).done) {
              _context30.next = 31;
              break;
            }

            u = _step17.value;
            d = $n(e, u);

            if (!(Ue(u) || u.type === "File")) {
              _context30.next = 12;
              break;
            }

            ue({
              dataFromPreviewApp: t.fields,
              updateFromEntryEditor: n,
              name: d
            });
            _context30.next = 29;
            break;

          case 12:
            if (!(u.type === "Link" && r < Y)) {
              _context30.next = 17;
              break;
            }

            _context30.next = 15;
            return Nt(t, n, s, d, i, r + 1, a, o);

          case 15:
            _context30.next = 29;
            break;

          case 17:
            if (!(u.type === "Array" && ((l = u.items) == null ? void 0 : l.type) === "Link" && r < Y)) {
              _context30.next = 22;
              break;
            }

            _context30.next = 20;
            return Tt(t, n, s, d, i, r + 1, a, o);

          case 20:
            _context30.next = 29;
            break;

          case 22:
            if (!(u.type === "RichText")) {
              _context30.next = 27;
              break;
            }

            _context30.next = 25;
            return _t(t, n, d, s, i, r, a, o);

          case 25:
            _context30.next = 29;
            break;

          case 27:
            if (!(u.type === "ResourceLink")) {
              _context30.next = 29;
              break;
            }

            return _context30.abrupt("return", (_.warn("Detected a resource link, support is still under development."), t));

          case 29:
            _context30.next = 5;
            break;

          case 31:
            _context30.next = 36;
            break;

          case 33:
            _context30.prev = 33;
            _context30.t0 = _context30["catch"](3);

            _iterator17.e(_context30.t0);

          case 36:
            _context30.prev = 36;

            _iterator17.f();

            return _context30.finish(36);

          case 39:
            return _context30.abrupt("return", t);

          case 40:
          case "end":
            return _context30.stop();
        }
      }
    }, _callee30, null, [[3, 33, 36, 39]]);
  }));
  return _Qn.apply(this, arguments);
}

var zn = /*#__PURE__*/function () {
  function zn(_ref21) {
    var _this9 = this;

    var t = _ref21.locale,
        n = _ref21.targetOrigin;

    _classCallCheck(this, zn);

    p(this, "subscriptions", /* @__PURE__ */new Map());
    p(this, "storage");
    p(this, "defaultLocale");
    p(this, "sendMessage");
    this.defaultLocale = t, this.sendMessage = function (s, i) {
      return g(s, i, n);
    }, this.storage = new At("live-updates", /* @__PURE__ */new Map()), window.addEventListener("beforeunload", function () {
      return _this9.clearStorage();
    });
  }

  _createClass(zn, [{
    key: "mergeEntity",
    value: function () {
      var _mergeEntity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref22) {
        var t, n, s, i, r, a;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                t = _ref22.contentType, n = _ref22.dataFromPreviewApp, s = _ref22.entityReferenceMap, i = _ref22.locale, r = _ref22.updateFromEntryEditor, a = _ref22.gqlParams;

                if (!("__typename" in n)) {
                  _context8.next = 9;
                  break;
                }

                _context8.next = 4;
                return n.__typename === "Asset" ? qe(n, r, a) : Xt({
                  contentType: t,
                  dataFromPreviewApp: n,
                  updateFromEntryEditor: r,
                  locale: i,
                  entityReferenceMap: s,
                  gqlParams: a,
                  sendMessage: this.sendMessage
                });

              case 4:
                _context8.t1 = _context8.sent;
                _context8.t2 = !0;
                _context8.t0 = {
                  data: _context8.t1,
                  updated: _context8.t2
                };
                _context8.next = 19;
                break;

              case 9:
                if (!this.isCfEntity(n)) {
                  _context8.next = 17;
                  break;
                }

                _context8.next = 12;
                return Qn(t, n, r, i, s, 0, /* @__PURE__ */new Map(), this.sendMessage);

              case 12:
                _context8.t4 = _context8.sent;
                _context8.t5 = !0;
                _context8.t3 = {
                  data: _context8.t4,
                  updated: _context8.t5
                };
                _context8.next = 18;
                break;

              case 17:
                _context8.t3 = {
                  updated: !1,
                  data: n
                };

              case 18:
                _context8.t0 = _context8.t3;

              case 19:
                return _context8.abrupt("return", _context8.t0);

              case 20:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function mergeEntity(_x74) {
        return _mergeEntity.apply(this, arguments);
      }

      return mergeEntity;
    }()
    /**
     * Merges the `dataFromPreviewApp` together with the `updateFromEntryEditor`
     * If there is not direct match, it will try to merge things together recursively
     * caches the result if cache is enabled and the entity has a `sys.id`.
     * Caching should not be enabled for every entry,
     * because nested references could be merged differently together and this could solve to data loss.
     */

  }, {
    key: "mergeNestedReference",
    value: function () {
      var _mergeNestedReference = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref23, s) {
        var t, n, i, r, a, o, l, _l, u;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                t = _ref23.dataFromPreviewApp, n = _objectWithoutProperties(_ref23, _excluded);
                i = V(t) && t.sys.id, r = s && i;
                a = !1, o = (r ? this.storage.get(i, n.locale) : void 0) || t;

                if (!(V(o) && i === n.updateFromEntryEditor.sys.id)) {
                  _context9.next = 10;
                  break;
                }

                _context9.next = 6;
                return this.mergeEntity(_objectSpread(_objectSpread({}, n), {}, {
                  dataFromPreviewApp: o
                }));

              case 6:
                l = _context9.sent;
                o = l.data, a = l.updated;
                _context9.next = 20;
                break;

              case 10:
                _context9.t0 = _regeneratorRuntime.keys(o);

              case 11:
                if ((_context9.t1 = _context9.t0()).done) {
                  _context9.next = 20;
                  break;
                }

                _l = _context9.t1.value;

                if (!(o[_l] && typeof o[_l] == "object")) {
                  _context9.next = 18;
                  break;
                }

                _context9.next = 16;
                return this.merge(_objectSpread(_objectSpread({}, n), {}, {
                  dataFromPreviewApp: o[_l]
                }), !1);

              case 16:
                u = _context9.sent;
                o[_l] = u.data, a = a || u.updated;

              case 18:
                _context9.next = 11;
                break;

              case 20:
                return _context9.abrupt("return", (r && this.storage.set(i, n.locale, o), {
                  data: o,
                  updated: a
                }));

              case 21:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function mergeNestedReference(_x75, _x76) {
        return _mergeNestedReference.apply(this, arguments);
      }

      return mergeNestedReference;
    }()
  }, {
    key: "merge",
    value: function () {
      var _merge = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref24) {
        var t,
            n,
            s,
            i,
            r,
            _iterator11,
            _step11,
            a,
            o,
            _args10 = arguments;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                t = _ref24.dataFromPreviewApp, n = _objectWithoutProperties(_ref24, _excluded2);
                s = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : !0;

                if (!Array.isArray(t)) {
                  _context10.next = 25;
                  break;
                }

                i = [];
                r = !1;
                _iterator11 = _createForOfIteratorHelper(t);
                _context10.prev = 6;

                _iterator11.s();

              case 8:
                if ((_step11 = _iterator11.n()).done) {
                  _context10.next = 16;
                  break;
                }

                a = _step11.value;
                _context10.next = 12;
                return this.mergeNestedReference(_objectSpread(_objectSpread({}, n), {}, {
                  dataFromPreviewApp: a
                }), s);

              case 12:
                o = _context10.sent;
                i.push(o.data), r = r || o.updated;

              case 14:
                _context10.next = 8;
                break;

              case 16:
                _context10.next = 21;
                break;

              case 18:
                _context10.prev = 18;
                _context10.t0 = _context10["catch"](6);

                _iterator11.e(_context10.t0);

              case 21:
                _context10.prev = 21;

                _iterator11.f();

                return _context10.finish(21);

              case 24:
                return _context10.abrupt("return", {
                  data: i,
                  updated: r
                });

              case 25:
                return _context10.abrupt("return", this.mergeNestedReference(_objectSpread(_objectSpread({}, n), {}, {
                  dataFromPreviewApp: t
                }), s));

              case 26:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[6, 18, 21, 24]]);
      }));

      function merge(_x77) {
        return _merge.apply(this, arguments);
      }

      return merge;
    }()
  }, {
    key: "isCfEntity",
    value: function isCfEntity(t) {
      return V(t) && "fields" in t;
    }
    /** Receives the data from the message event handler and calls the subscriptions */

  }, {
    key: "receiveMessage",
    value: function () {
      var _receiveMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(t) {
        var _this10 = this;

        var n, s, i;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!("action" in t && t.action === "ENTRY_UPDATED" || t.method === L.ENTRY_UPDATED)) {
                  _context12.next = 4;
                  break;
                }

                n = t.entity, s = t.contentType, i = t.entityReferenceMap;
                _context12.next = 4;
                return Promise.all(_toConsumableArray(this.subscriptions).map( /*#__PURE__*/function () {
                  var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref25) {
                    var _ref27, r, _yield$_this10$merge, a, o;

                    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                      while (1) {
                        switch (_context11.prev = _context11.next) {
                          case 0:
                            _ref27 = _slicedToArray(_ref25, 2), r = _ref27[1];
                            _context11.prev = 1;
                            _context11.next = 4;
                            return _this10.merge({
                              // Clone the original data on the top level,
                              // to prevent cloning multiple times (time)
                              // or modifying the original data (failure potential)
                              dataFromPreviewApp: de(r.data),
                              locale: r.locale || _this10.defaultLocale,
                              updateFromEntryEditor: n,
                              contentType: s,
                              entityReferenceMap: i,
                              gqlParams: r.gqlParams
                            });

                          case 4:
                            _yield$_this10$merge = _context11.sent;
                            a = _yield$_this10$merge.updated;
                            o = _yield$_this10$merge.data;
                            a && r.callback(o);
                            _context11.next = 13;
                            break;

                          case 10:
                            _context11.prev = 10;
                            _context11.t0 = _context11["catch"](1);
                            _this10.sendErrorMessage({
                              message: _context11.t0.message,
                              payload: {
                                data: r.data,
                                update: n
                              },
                              type: "SUBSCRIPTION_UPDATE_FAILED"
                            }), _.error("Failed to apply live update", {
                              error: _context11.t0,
                              subscribedData: r.data,
                              updateFromEditor: n
                            });

                          case 13:
                          case "end":
                            return _context11.stop();
                        }
                      }
                    }, _callee11, null, [[1, 10]]);
                  }));

                  return function (_x79) {
                    return _ref26.apply(this, arguments);
                  };
                }()));

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function receiveMessage(_x78) {
        return _receiveMessage.apply(this, arguments);
      }

      return receiveMessage;
    }()
  }, {
    key: "restore",
    value: function () {
      var _restore = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(t, n, s) {
        var _this11 = this;

        var i, r, o, a;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (t) {
                  _context13.next = 2;
                  break;
                }

                return _context13.abrupt("return");

              case 2:
                i = function i(o) {
                  if (V(o)) {
                    var l = _this11.storage.get(o.sys.id, n);

                    if (l) return l;
                  }

                  return o;
                };

                if (Array.isArray(t)) r = t.map(i);else {
                  o = i(t);
                  o !== t && (r = o);
                }
                a = this.subscriptions.get(s);
                a && r && a.callback(r);

              case 6:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function restore(_x80, _x81, _x82) {
        return _restore.apply(this, arguments);
      }

      return restore;
    }()
  }, {
    key: "clearStorage",
    value: function clearStorage() {
      this.storage.clear();
    }
  }, {
    key: "sendErrorMessage",
    value: function sendErrorMessage(t) {
      this.sendMessage(L.ERROR, t);
    }
    /**
     * Subscribe to data changes from the Editor, returns a function to unsubscribe
     * Will be called once initially for the restored data
     */

  }, {
    key: "subscribe",
    value: function subscribe(t) {
      var _this12 = this;

      var _Kn = Kn(t),
          n = _Kn.isGQL,
          s = _Kn.isValid,
          i = _Kn.sysId,
          r = _Kn.isREST,
          a = _Kn.config;

      if (!s) return this.sendErrorMessage({
        message: "Failed to subscribe",
        payload: {
          isGQL: n,
          isValid: s,
          sysId: i,
          isREST: r
        },
        type: "SUBSCRIPTION_SETUP_FAILED"
      }), function () {};
      var o = bt(),
          l = a.locale || this.defaultLocale;
      return this.subscriptions.set(o, _objectSpread(_objectSpread({}, a), {}, {
        sysId: i,
        gqlParams: a.query ? Wt(a.query) : void 0
      })), setTimeout(function () {
        _this12.restore(a.data, l, o);
      }, 0), this.sendMessage(L.SUBSCRIBED, {
        action: L.SUBSCRIBED,
        type: n ? "GQL" : "REST",
        locale: l,
        entryId: i,
        event: "edit"
      }), function () {
        _this12.subscriptions.delete(o);
      };
    }
  }]);

  return zn;
}();

var Jn = /*#__PURE__*/function () {
  function Jn(_ref28) {
    var t = _ref28.locale;

    _classCallCheck(this, Jn);

    p(this, "locale");
    p(this, "subscription");
    this.locale = t;
  }

  _createClass(Jn, [{
    key: "subscribe",
    value: function subscribe(t) {
      var _this13 = this;

      return this.subscription && _.log("There is already a subscription for the save event, the existing one will be replaced."), this.subscription = t, function () {
        _this13.subscription = void 0;
      };
    }
  }, {
    key: "receiveMessage",
    value: function receiveMessage(t) {
      if (t.method === L.ENTRY_SAVED && this.subscription) {
        var n = t.entity;
        Ve().includes(n.sys.id) && this.subscription(n);
      }
    }
  }]);

  return Jn;
}();

var ei = Be,
    qn = ["https://app.contentful.com", "https://app.eu.contentful.com"],
    D = /*#__PURE__*/function () {
  function D() {
    _classCallCheck(this, D);
  }

  _createClass(D, null, [{
    key: "init",
    value: // Static method to initialize the LivePreview SDK
    function init(t) {
      var _this14 = this;

      var o;
      if (typeof t != "object" || !(t != null && t.locale)) throw new Error("Init function have to be called with a locale configuration (for example: `ContentfulLivePreview.init({ locale: 'en-US'})`)");
      var n = t.debugMode,
          s = t.enableInspectorMode,
          i = t.enableLiveUpdates,
          r = t.locale,
          _t$targetOrigin = t.targetOrigin,
          a = _t$targetOrigin === void 0 ? qn : _t$targetOrigin;

      if (typeof window < "u") {
        if (!Ct()) return this.liveUpdatesEnabled = !1, Promise.resolve(null);
        if (n && _e(n), typeof s == "boolean" && (this.inspectorModeEnabled = s), typeof i == "boolean" && (this.liveUpdatesEnabled = i), this.locale = r, this.targetOrigin = Array.isArray(a) ? a : [a], this.initialized) return _.log("You have already initialized the Live Preview SDK."), Promise.resolve(D.inspectorMode);
        this.inspectorModeEnabled && (this.inspectorMode = new Kt({
          locale: r,
          targetOrigin: this.targetOrigin,
          ignoreManuallyTaggedElements: (o = t.experimental) == null ? void 0 : o.ignoreManuallyTaggedElements
        })), this.liveUpdatesEnabled && (this.liveUpdates = new zn({
          locale: r,
          targetOrigin: this.targetOrigin
        }), this.saveEvent = new Jn({
          locale: r
        })), window.addEventListener("message", function (u) {
          var d, h, E;

          if (wt(u)) {
            if (_.log("Received message", u.data), "action" in u.data && u.data.action === "DEBUG_MODE_ENABLED" || u.data.method === L.DEBUG_MODE_ENABLED) {
              _e(!0);

              return;
            }

            _this14.inspectorModeEnabled && ((d = _this14.inspectorMode) == null || d.receiveMessage(u.data)), _this14.liveUpdatesEnabled && ((h = _this14.liveUpdates) == null || h.receiveMessage(u.data), (E = _this14.saveEvent) == null || E.receiveMessage(u.data));
          }
        }), vt(function () {
          g(L.URL_CHANGED, {
            action: L.URL_CHANGED,
            taggedElementCount: document.querySelectorAll("[".concat(N.ENTRY_ID, "]")).length
          }, _this14.targetOrigin);
        });
        var l = document.querySelectorAll("[".concat(N.ENTRY_ID, "]")).length;
        return g(L.CONNECTED, {
          action: L.CONNECTED,
          connected: !0,
          tags: l,
          taggedElementCount: l,
          locale: this.locale,
          isInspectorEnabled: this.inspectorModeEnabled,
          isLiveUpdatesEnabled: this.liveUpdatesEnabled
        }, this.targetOrigin), this.initialized = !0, Promise.resolve(D.inspectorMode);
      }
    }
  }, {
    key: "subscribe",
    value: function subscribe(t, n) {
      if (!this.liveUpdatesEnabled) return function () {};
      var s = typeof t == "string" ? t : "edit",
          i = typeof t == "object" ? t : n;

      if (s === "save") {
        if (!this.saveEvent) throw new Error("Save event is not initialized, please call `ContentfulLivePreview.init()` first.");
        return this.saveEvent.subscribe(i.callback);
      }

      if (!this.liveUpdates) throw new Error("Live updates are not initialized, please call `ContentfulLivePreview.init()` first.");
      return this.liveUpdates.subscribe(i);
    } // Static method to render live preview data-attributes to HTML element output

  }, {
    key: "getProps",
    value: function getProps(t) {
      var _ref29, _ref30;

      var n = t.fieldId,
          s = t.locale;
      return this.inspectorModeEnabled ? t.assetId !== void 0 && n ? (_ref29 = {}, _defineProperty(_ref29, N.FIELD_ID, n), _defineProperty(_ref29, N.ASSET_ID, t.assetId), _defineProperty(_ref29, N.LOCALE, s), _ref29) : t.entryId !== void 0 && n ? (_ref30 = {}, _defineProperty(_ref30, N.FIELD_ID, n), _defineProperty(_ref30, N.ENTRY_ID, t.entryId), _defineProperty(_ref30, N.LOCALE, s), _ref30) : (_.warn("Missing property for inspector mode", _objectSpread({}, t)), null) : null;
    }
  }, {
    key: "toggleInspectorMode",
    value: function toggleInspectorMode() {
      return this.inspectorModeEnabled = !this.inspectorModeEnabled, this.inspectorModeEnabled;
    }
  }, {
    key: "toggleLiveUpdatesMode",
    value: function toggleLiveUpdatesMode() {
      return this.liveUpdatesEnabled = !this.liveUpdatesEnabled, this.liveUpdatesEnabled;
    }
  }, {
    key: "openEntryInEditor",
    value: function openEntryInEditor(t) {
      if (t.assetId !== void 0 && t.fieldId) {
        Hn(t.fieldId, t.assetId, t.locale || this.locale, this.targetOrigin);
        return;
      }

      if (t.entryId !== void 0 && t.fieldId) {
        Yn(t.fieldId, t.entryId, t.locale || this.locale, this.targetOrigin);
        return;
      }

      _.error("Please provide field id and entry id to openEntryInEditor.");
    }
    /**
     * Returns a list of tagged entries on the page
     */

  }, {
    key: "getEntryList",
    value: function getEntryList() {
      return Ve();
    }
  }]);

  return D;
}();

p(D, "initialized", !1), p(D, "inspectorMode", null), p(D, "liveUpdates", null), p(D, "saveEvent", null), p(D, "inspectorModeEnabled", !0), p(D, "liveUpdatesEnabled", !0), p(D, "locale"), p(D, "sendMessage"), p(D, "targetOrigin");
var we = D;
export { we as C, C as I, Dt as L, Ie as P, ei as V, gt as a, L as b, S as c, Xn as d, Hn as e, Zn as g, Yn as o };